<template>
    <div>
    <!--- Nav Bar main --->
    <nav-bar-main></nav-bar-main>

    <nav-bar-dispositivi></nav-bar-dispositivi>
 
    <!--- Modal for remove central unit --->
    <remove-central-unit :cu="cuToRemove" v-model="modalRemoveCuVisible" @hide="resetRemoveCuModal"/>  

    <!--- Modal for view groups on a central unit --->
    <groups-central-unit :cu="cuGroups" v-model="modalGroupsCuVisible" @hide="resetGroupsCuModal"/>  

    <!--- Modal for view groups on a central unit --->
    <advanced-central-unit :cu="cuAdvanced" v-model="modalAdvancedCuVisible" @hide="resetAdvancedCuModal"/>  

    <!--<nav-bar-basic  v-else></nav-bar-basic>-->        

        <div v-if="plantDetails != null" class="animated fadeIn container-fluid">
            <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
                <div>
                
                <!-- navbar dei comandi visibile solo se admin o installatore o collaboratore -->
                <b-row v-if="this.ruoloUtente(this.$store.getters.userId)=='installer' || this.ruoloUtente(this.$store.getters.userId)=='collab' ||  this.$store.state.user.usertype=='admin'" class="fixed-top navbar-command">
                    <b-col lg="12" md="12">

                    <!-- banner error on plant -->
                    <div v-if="error != null" class="alert alert-danger" role="alert">
                        {{$t(error)}}
                    </div>

                    <!-- banner per basic plant -->
                    <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
                        <banner-pro/>
                    </b-alert>
                    
                    <!-- banner per pro expired -->
                    <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
                        <banner-pro-expired/>
                    </b-alert>
                    
                    <!-- alert per feedback dei comandi -->
                    <b-row class="alert-feeback-command">  
                    <b-col lg="12" md="12">
                        <b-alert v-for="(alert,indexA) in alerts" :show="alert.timeLeft" v-bind:key="indexA" :variant="alert.state"
                                dismissible
                                fade
                                @dismissed="alert.timeLeft=0"
                                @dismiss-count-down="alert.countDownChanged">
                                <div>
                                <i v-if="alert.state=='danger'" class="fa fa-1x fa-exclamation-circle mr-2"></i>
                                <i v-if="alert.state=='success'" class="fa fa-1x fa-check-circle mr-2"></i>
                                <div class="pb-3" style="display:inline; font-size:13px; height:15px;">{{alert.msg}}</div></div>
                        </b-alert>
                    </b-col>
                    </b-row>

                    <!--- Loader per il caricamento pagina o invio dei comandi -->
                    <Loader/>

                    <!-- barra dei comandi -->
                    <b-row class="pull-left ml-4" style="width: 100%">
                            <add-central-unit> </add-central-unit>
                            <b-dropdown  id="test_command" class="typo-label mr-1 ml-1 mt-3">
                                <template slot="button-content">
                                    <i class="fa fa-bolt"></i>
                                    <span class="ml-2 mr-2 typo-label">{{$t("command_button.test")}}</span>
                                </template>
                                <b-dropdown-item @click="sendGenericCommand('test_funzionale')">{{$t('command.test_funzionale')}}</b-dropdown-item>
                                <b-dropdown-item @click="sendGenericCommand('test_autonomia')">{{$t('command.test_autonomia')}}</b-dropdown-item>
                                <b-dropdown-item @click="sendGenericCommand('stop_test')">{{$t('command.stop_test')}}</b-dropdown-item>
                            </b-dropdown>
                            <b-dropdown  id="generic_command" text="Comandi" class="typo-label mr-1 ml-1 mt-3">
                                <template slot="button-content">
                                    <i class="fa fa-paper-plane"></i>
                                    <span class="ml-2 mr-2 typo-label">{{$t("command_button.command")}}</span>
                                </template>
                                <b-dropdown-item @click="sendGenericCommand('rest_mode')">{{$t('command.rest_mode')}}</b-dropdown-item>
                                <b-dropdown-item @click="sendGenericCommand('refresh')">{{$t('command.refresh')}}</b-dropdown-item>
                                <b-dropdown-item @click="sendGenericCommand('stop_blink')">{{$t('command.stop_blink')}}</b-dropdown-item>
                            </b-dropdown>
                            <parametri-impianto :sendAction="sendGenericCommandMulti" :lamp="lampadeSel" :cu="centraliSel" :group="gruppoSel" :alerts="alerts" class="pull-right"></parametri-impianto>
                            <pianifica-test :sendAction="sendPianificaTest" :cu="centraliSel" :alerts="alerts" :timezoneLocation="this.$store.state.timezoneLocation"></pianifica-test>
                            <parametri-uvoxy :sendAction="sendGenericCommandMulti" :lamp="lampadeSel" :cu="centraliSel" :alerts="alerts" class="pull-right"></parametri-uvoxy>
                    
                            <div id="navbar-search">
                                <div id="navbar-filter" v-if="!advancedFilters">     
                                        <b-input-group>
                                            <b-form-input type="text" placeholder="Cerca" v-model="filters.search"></b-form-input>
                                            <b-input-group-append>
                                                <b-button variant="primary" @click="filtra()"><i class="fa fa-search"></i> </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                </div>
                                
                                <div id="navbar-filter" v-if="!advancedFilters">
                                    <b-link href="#" @click="showFilters()"><i class="fa fa-filter"></i> Filtri</b-link>
                                </div>
                            </div>
                            
                        </b-row>    
                    </b-col>
                </b-row>
                </div>
            </show-at>
            <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
                <div>
                    <b-nav class="mobile-sub-nav fixed-top">
                        <!--<b-button size="sm" v-b-toggle.commands-collapse>+</b-button>-->
                        <b-nav-text style="padding-left:16px"> {{$t("navbar_dispositivi.button_centrali")}}</b-nav-text>
                        <!--<b-dropdown id="dd-centrali-menu" right no-caret >
                            <template v-slot:button-content>
                            <i class="fa fa-bars fa-lg"></i>
                            </template>
                            <b-dropdown-item class="active">{{$t("navbar_dispositivi.button_centrali")}}</b-dropdown-item>
                            <b-dropdown-item :to="{path: '/plantgeneral/'+ this.$store.state.currentPlant.id}" >{{$t("navbar.settings_generali")}}</b-dropdown-item>
                            <b-dropdown-item :to="{path: '/plantusers/'+ this.$store.state.currentPlant.id}">{{$t("navbar.settings_utenti")}}</b-dropdown-item>
                        </b-dropdown>-->
                    </b-nav>
                </div>
            </show-at>

            <!-- Tabella dispositivi -->
            <b-row id="table-device">              
                <b-col cols="12" class="mainDataCol">
        
            <!-- Visualizzazione desktop ---->
                    <hide-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
                    <b-check-group id="righeSel" v-model="righeSel">
                    <!---- TABLE CENT -->    
                    <v-client-table v-if="tableData.length>=0" :columns="columns" :data="tableData" :options="options" :theme="theme" id="dataTable2" ref="table" class="table-dispo borderless text-primary styled">                       
                        <!--<checkbox for header (prefix column name with h__-->
                         <tr  v-if="this.ruoloUtente(this.$store.getters.userId)=='installer' || this.ruoloUtente(this.$store.getters.userId)=='collab'" slot="prependBody">
                            <td></td>
                            <td colspan="10" style="text-align:left;vertical-align:middle; background:none">
                                <div style="display: flex;align-items: center">
                                    
                                    <!-- Barra di selezione di tutti i dispositivi, creazione e selezione gruppi -->
                                    <div v-if="!advancedFilters" style="padding-left: 20px; flex-grow: 1">
                                        <b-checkbox v-if="selectedGroup==''" @change="toggleSeleziona()" id="allSelect" value="x" class="float-left pr-1 mt-2 mb-2">
                                            <span class="typo-label">{{$t("select_checkbox.text")}}</span>
                                        </b-checkbox>
                                        <div v-else class="float-left pr-1 mt-1 mb-2">
                                                <div style="color:#0090CD" class="h6 float-left mt-2">{{$t("select_checkbox.group",{group: selectedGroup})}}</div>
                                        </div>
                                        <select v-if="lampadeSel.length==0 && centraliSel.length==0 || selectedGroup!=''"  @change="filtra()" class="float-right pr-1 mt-1 mr-2 mb-2" v-model="selectedGroup" style="width:50px;">
                                            <option v-for="group in groups" :selected="selectedGroup === group">{{ group }}</option>
                                        </select>
                                        <label v-if="lampadeSel.length==0 && centraliSel.length==0 || selectedGroup!=''" class="float-right typo-label pr-1 mt-1 ml-3">{{$t("select_group.text")}}</label>
                                        
                                        <rimuovi-gruppo v-if="lampadeSel.length>0 || centraliSel.length>0 && selectedGroup==''" class="ml-2 float-right" :sendAction="sendGenericCommandMulti" :lamp="lampadeSel" :cu="centraliSel" :alerts="alerts"></rimuovi-gruppo>
                                        <crea-gruppo v-if="lampadeSel.length>0 || centraliSel.length>0 && selectedGroup==''" class="float-right" :sendAction="sendGenericCommandMulti" :lamp="lampadeSel" :cu="centraliSel" :alerts="alerts"></crea-gruppo>
                                        <b-button class="noborder-button download float-right" @click="createPDF_Impianto()">
                                            <i class="fas fa fa-1x fa-download mr-3"></i>
                                            <span v-if="lampadeSel.length==0 && centraliSel.length==0">{{this.$t('report_pdf.download_all_pdf')}}</span>
                                            <span v-if="centraliSel.length>0 || lampadeSel.length>0">{{this.$t('report_pdf.download_selected_pdf')}}</span>
                                        </b-button>
                                     </div>
                                    
                                    <div v-if="advancedFilters" style="margin-right: 10px;">
                                        <b-link href="#" @click="hideFilters()">Ricerca semplice</b-link>
                                    </div>
                                </div>
                                <b-collapse id="collapse-filter-panel" v-model="advancedFilters">
                                    <b-card header="Ricerca Avanzata" header-bg-variant="primary" border-variant="primary" header-text-variant="white" class="mt-2 mb-0 typo-label">
                                        <b-row>                                        
                                            <b-col cols="3">
                                                <b-row>
                                                    <b-col cols="12">
                                                        <b-form-group>
                                                            <label for="flt-idCentrale" >ID Centrale</label>
                                                            <b-form-input type="text" id="flt-idCentrale" v-model="filters.idCent"></b-form-input>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col cols="12">
                                                        <b-form-group>
                                                            <label for="flt-nomeCentrale">Nome Centrale</label>
                                                            <b-form-input type="text" id="flt-nomeCentrale" v-model="filters.nomeCent"></b-form-input>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                 <b-row class="mt-3">
                                                    <b-col cols="12">
                                                        <b-card class="h-100" header="Tipo Centrale" no-body>                                          
                                                            <b-form-checkbox-group id="flt-tipoCentrale" name="flt-tipoCentrale" v-model="filters.tipoCent" :checked="['all']" class="px-2 pt-2" @change="tipoCentChanged">
                                                            <b-form-checkbox value="all">Tutte</b-form-checkbox>
                                                            <b-form-checkbox value="cablecom">Cablecom</b-form-checkbox>
                                                            <b-form-checkbox value="logica">Logica</b-form-checkbox>
                                                            </b-form-checkbox-group>
                                                        </b-card>
                                                    </b-col>
                                                </b-row>
                                            </b-col>  


                                            <b-col cols="3">
                                                <b-row>
                                                    <b-col cols="12">
                                                        <b-form-group>
                                                            <label for="flt-idLampada">ID Lampada</label>
                                                            <b-form-input type="text" id="flt-idLampada" v-model="filters.idLamp"></b-form-input>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>    
                                                <b-row>
                                                    <b-col cols="12">
                                                        <b-form-group>
                                                            <label for="flt-nomeLampada">Nome Lampada</label>
                                                            <b-form-input type="text" id="flt-nomeLampada" v-model="filters.nomeLamp"></b-form-input>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="mt-3">
                                                    <b-col cols="12">
                                                        <b-card class="h-100" header="Tipo Lampada" no-body>
                                                            <b-form-radio-group id="flt-tipoLamp" 
                                                                :plain="true"
                                                                v-model="filters.tipoLamp"
                                                                :options="[
                                                                    {text: 'Tutte',value: 'all'},
                                                                    {text: 'SE',value: 'SE'},
                                                                    {text: 'SA',value: 'SA'},
                                                                    {text: 'UV-Oxy',value: 'oxy'},
                                                                    {text: 'No UV-Oxy',value: 'no-oxy'}
                                                                ]"
                                                                checked="all" class="px-2 pt-2"
                                                            >
                                                            </b-form-radio-group>
                                                        </b-card>
                                                    </b-col>
                                                </b-row>
                                            </b-col>    

                                            <b-col cols="6 mt-4">
                                                <b-row> 
                                                    <b-col cols="6">
                                                        <b-card class="h-100"
                                                        header="Autonomia"
                                                        no-body
                                                        >
                                                        <b-form-checkbox-group id="flt-autonomia" name="flt-autonomia" v-model="filters.autonomia" :checked="['all']" class="px-2 pt-2" @change="autonomiaChanged">
                                                        
                                                        <b-form-checkbox value="all">Tutte</b-form-checkbox>
                                                        <b-form-checkbox value="1H">1H</b-form-checkbox>
                                                        <b-form-checkbox value="1H5">1H5</b-form-checkbox>
                                                        <b-form-checkbox value="2H">2H</b-form-checkbox>
                                                        <b-form-checkbox value="3H">3H</b-form-checkbox>
                                                        <b-form-checkbox value="8H">8H</b-form-checkbox>
                                                        
                                                        </b-form-checkbox-group>
                                                        </b-card>
                                                    </b-col>
                                                    <b-col cols="6">
                                                    <b-card class="h-100"
                                                        header="Presenza rete"
                                                        no-body
                                                        >
                                                    <b-form-radio-group id="flt-rete"
                                                        :plain="true"
                                                        v-model="filters.rete_se"
                                                        :options="[
                                                            {text: 'Tutte',value: 'all'},
                                                            {text: 'Rete SE presente',value: 'SE_ON'},
                                                            {text: 'Rete SE assente',value: 'SE_OFF'}
                                                        ]"
                                                        checked="all" class="px-2 pt-2"
                                                        >
                                                        </b-form-radio-group>
                                                    </b-card>
                                                </b-col>

                                                </b-row>

                                                <b-row class="mt-5 mb-3">    
                                                <b-col cols="6">
                                                    <b-card class="h-100"
                                                        header="Parità"
                                                        no-body
                                                        >
                                                    <b-form-radio-group id="flt-parita"
                                                        :plain="true"
                                                        v-model="filters.parita"
                                                        :options="[
                                                            {text: 'Tutte',value: 'all'},
                                                            {text: 'Pari',value: 'PARI'},
                                                            {text: 'Dispari',value: 'DISPARI'}
                                                        ]"
                                                        checked="all" class="px-2 pt-2"
                                                        >
                                                        </b-form-radio-group>
                                                    </b-card>
                                                </b-col>

                                                <b-col cols="6">
                                                <b-card class="h-100"
                                                    header="Infinity Mode"
                                                    no-body
                                                    >
                                                    <b-form-radio-group id="flt-infinity"
                                                    :plain="true"
                                                    v-model="filters.infinity"
                                                    :options="[
                                                        {text: 'Tutte',value: 'all'},
                                                        {text: 'ON',value: 'ABILITATO'},
                                                        {text: 'OFF',value: 'DISABILITATO'}
                                                    ]"
                                                    checked="all" class="px-2 pt-2"
                                                    >
                                                    </b-form-radio-group>
                                                </b-card>
                                                </b-col>
                                              </b-row>    
                                            </b-col>
                                        </b-row>        
                       
                                        <b-row class="mt-2"><b-col class="text-right">
                                            <b-button size="sm" variant="warning" @click="clearFilters()" class="mr-4"><i class="fa fa-eraser"></i> Azzera Filtri</b-button> 
                                            <b-button size="sm" variant="primary" @click="filtra()"><i class="fa fa-filter"></i> Filtra</b-button></b-col></b-row>
                                    </b-card>
                                </b-collapse>
                            </td>
                            
                        </tr>

                        <!-- checkbox for each row-->
                        <div slot="check" slot-scope="props">
                            <b-checkbox :disabled="!props.row.enabled" @click.native="toggleCentCheckbox" :value="'cent-'+(props.index-1)" :id="'cent-'+props.row.cu_type+'-'+props.row.cu_id" />
                        </div>
                        <div slot="image" slot-scope="props">    
                            <div><img  :src="'/img/'+ props.row.cu_type + '/centrale_small.png'" style="height:30px; width:auto;" /></div>
                        </div>
                        <div slot="desc"  slot-scope="props">
                                    <b-row class="child-table"><strong><span class="sp_cent_id" v-if="props.row.cu_desc!='--'">{{props.row.cu_desc}}</span></strong></b-row>
                                    <b-row class="child-table"><span class="sp_cent_id">{{$t("central_unit")}} {{props.row.cu_type}}</span>
                                         <i  class="fa fa-1x fa-exclamation-circle ml-2" v-bind:class="[centErrorClass(props.row)]"></i>
                                    </b-row>
                        </div>                                   
                            <div slot="dettaglio" slot-scope="props">
                                <b-dropdown v-if="props.row.enabled" variant="link" size="lg" toggle-class="text-decoration-none" no-caret right id="dropdown-central">
                                    <template slot="button-content">
                                        <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                    </template>
                                    <b-dropdown-item @click="showCentDetails(props.row)">{{$t("cu_table_row.dropdown_dettaglio")}}</b-dropdown-item>
                                    <b-dropdown-item v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')" @click="showConfigCent(props.row)">{{$t("cu_table_row.dropdown_configura")}}</b-dropdown-item>
                                    <b-dropdown-item v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')" @click="showRemoveCu(props.row)">{{$t("remove_cu_button.text")}}</b-dropdown-item>
                                    <b-dropdown-item v-if="props.row.cu_type=='logica' && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')" @click="showGroups(props.row)">{{$t("lamp_details_modal.groups")}}</b-dropdown-item>
                                    <b-dropdown-item v-if="props.row.cu_type=='logicafm' && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')" @click="showGroups(props.row)">{{$t("lamp_details_modal.groups")}}</b-dropdown-item>
                                    <b-dropdown-item v-if="props.row.cu_type=='logicafm' && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')" @click="showAdvanced(props.row)">{{$t("lamp_details_modal.advanced")}}</b-dropdown-item>
                                </b-dropdown>
                            </div>  
                        <div slot="connesso" slot-scope="props" class="text-left">
                            <i class="fa fa-circle" v-bind:class="[onlineClass(props.row)]" /> {{ descrStato(props.row) }}
                        </div>
                        <div slot="centrale" slot-scope="props" class="text-center">
                                <div class="d-flex justify-content-right">{{$t("id_cu")}}</div>
                                <strong><div class="d-flex justify-content-right">{{props.row.cu_id}}</div></strong>
                        </div>
                        <div slot="lampade" slot-scope="props">
                            <!--- visualizza il numero delle lampade oppure attende sync della shadow -->
                            <strong><div v-if="props.row.num_lamp_found>=0" class="d-flex justify-content-center">{{props.row.num_lamp_found}}</div></strong>
                            <div v-if="props.row.num_lamp_found>=0" class="d-flex justify-content-center">{{$t("lamps_found")}}</div>
 
                            <div v-if="props.row.cu_type!='cablecom' && props.row.num_lamp_found>=0 && props.row.num_lamp_present!=props.row.num_lamp_found" class="justify-content-center d-inline" style="color:orangered; font-size:12px">{{props.row.num_lamp_present}} </div>
                            <div v-if="props.row.cu_type!='cablecom' && props.row.num_lamp_found>=0 && props.row.num_lamp_found!=props.row.num_lamp_present" class="justify-content-center d-inline" style="color:orangered; font-size:12px">{{$t("lamps_present")}}</div>
 
                            <div v-if="props.row.num_lamp_found<0" class="sk-wave" style="margin:0; width:auto;height:20px">
                                <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div> 
                                <div> SYNC </div>
                            </div>
                        </div>
                        <div v-if="working(props.row) && props.row.cu_connected || testactive(props.row) || waiting_first_shadow(props.row) || restmodeactive(props.row)" slot="stato" slot-scope="props">      
                                    <div  v-if="working(props.row) && props.row.cu_connected">
                                        <i class="fa fa-2x fa-spinner fa-spin" style="color:grey"></i>
                                    </div>
                                    <div v-if="testactive(props.row)"> 
                                         <div><i class="fa fa-battery-three-quarters" style="color:orange"></i></div>
                                         <div class="typo-icon">{{$t("param_lamp.TEST IN CORSO")}}</div>   
                                    </div>
                                    <div v-if="waiting_first_shadow(props.row)"> 
                                         <div><i class="fa fa-2x fa-spinner fa-spin" style="color:orange"></i></div>
                                         <div class="typo-icon">SYNC</div>   
                                    </div>
                                    <div v-if="restmodeactive(props.row)"> 
                                         <div><i class="fa fa-caret-square-down" style="color:orange"></i></div>
                                         <div class="typo-icon">{{$t("param_lamp.REST MODE ACTIVATED")}}</div>   
                                    </div>  
                        </div>       
                        <div v-else slot="stato" slot-scope="props">
                            <i class="fa fa-2x" v-bind:class="[dotClass(props.row)]" /> 
                        </div>  

                        <div v-if="props.row.enabled" slot="child_row" slot-scope="props">

                        <!--- tabella lampade -->        
                        <table class="table table-child" id="dataTableChild">
                                <tbody>
                                    <tr v-for="(lamp,lampindex) in props.row.lamps" v-bind:key="lamp.id" class="tr_child" :style="{'display': (lamp['visible'] == false) ? 'none':'table-row' }">
                                        <td><div style="display:inline-block; width: 21px"></div></td>
                                        <td tabindex="0" style="width:80px; max-width: 80px; min-width:80px">
                                            <b-checkbox :disabled="!props.row.enabled || centSelObject(props.row)==true || selectedGroup!=''" :value="'lamp-'+(props.index-1)+'-'+lampindex" :id="'lamp-'+(props.index-1)+'-' + lampindex" />
                                        <td class="imgColumnClass" >                
                                            <img v-if="lamp.product_image!=null" :src="'/img/apparecchi/' + lamp.product_image" style="height:60px; width:auto;" />
                                        </td>
                                        <td class="descColumnClass">
                                            <b-row class="child-table"><strong><span v-if="lamp.desc!=null">{{lamp.desc}}</span></strong></b-row>
                                            <b-row class="child-table"><strong>ID:<span>{{lamp.id}}</span></strong></b-row>
                                            <b-row class="child-table">
                                                <span v-if="lamp.product_code!=null">cod. {{lamp.product_code}}</span>
                                                <img v-if="lamp.lamp_type=='SA'" src="/img/SA.png" class="icon-lamp-type"></img>
                                                <img v-if="lamp.lamp_type=='SE'" src="/img/SE.png" class="icon-lamp-type"></img>
                                                <img v-if="lamp.fan_sanifica && lamp.fan_sanifica!='--'" src="/img/uvoxyIcon.png" class="icon-lamp-type"></img>
                                            </b-row>
                                            <b-row class="child-table" v-if="lamp.product_desc!=null">
                                                <span >{{lamp.product_desc}}</span>
                                            </b-row> 
                                        </td>  
                                        <td>
                                            <!---slot action -->        
                                        </td>        
                                        <td class="dettColumnClass">
                                            <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none" no-caret right>
                                                <template slot="button-content">
                                                    <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                                </template>
                                                <b-dropdown-item @click="showLampDetails(props.row,lamp)">{{$t("cu_table_row.dropdown_dettaglio")}}</b-dropdown-item>
                                                <div class="dropdown-divider" v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type!='logica'"></div>
                                                <b-dropdown-item @click="showLampBlink(props.row,lamp)" v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type!='logica'">{{$t("cu_table_row.dropdown_blink")}}</b-dropdown-item>
                                            </b-dropdown>
                                        </td>
                                        <td style="text-align:left">
                                            <!-- <i class="fa fa-circle" v-bind:class="[onlineClass(props.row)]" /> {{ descrStato(props.row) }} -->
                                        </td>
                                        <td>    
                                            <div v-if="lamp.lamp_type!='SE'" class="d-flex justify-content-center">{{$t("details_lamp.lamp_sa_dimming")}}</div>                                                              
                                            <strong><div v-if="lamp.lamp_type!='SE' && lamp.shadow_pending" v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('sa_dimming'))]">
                                                {{lamp.sa_dimming}}
                                                <i v-if="lamp.sa_dimming!='SE' && lamp.sa_presence=='SA PRESENTE'" class="fas fa-lightbulb" style="color:gold"></i>
                                                <i v-if="lamp.sa_dimming!='SE' && lamp.sa_presence=='SA NON PRESENTE'" class="far fa-lightbulb" style="color:black"></i>
                                            </div></strong>                        
                                        </td> 
                                        <td>
                                            <div class="d-flex justify-content-center">{{$t("details_lamp.lamp_autonomy")}}</div>
                                            <strong v-if="lamp.shadow_pending" v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('autonomy'))]"><div class="d-flex justify-content-center">{{lamp.autonomy}}</div></strong>
                                        </td>     
                                        <td  v-if="lamp.fan_sanifica && lamp.fan_sanifica!='--'">
                                            <div class="d-flex justify-content-center">{{$t("details_lamp.lamp_sanifica")}}</div>
                                            <strong v-if="lamp.shadow_pending" v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('tuboUV_fase_sanifica'))]"><div class="d-flex justify-content-center">{{lamp.tuboUV_fase_sanifica.toUpperCase()}}</div></strong>
                                        </td>   
                                        <td  v-else>
                                            <div class="d-flex justify-content-center">{{$t("details_lamp.lamp_parity")}}</div>
                                            <strong v-if="lamp.shadow_pending" v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('parity'))]"><div class="d-flex justify-content-center">{{$t("param_lamp." + lamp.parity ).toUpperCase()}}</div></strong>
                                        </td>   
                                        <td v-if="lamp.lssa && !props.row.cu_type.startsWith('logica')">
                                            <div class="d-flex justify-content-center">{{$t("details_lamp.lamp_infinity")}}</div>
                                            <strong v-if="lamp.shadow_pending" v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('lssa'))]"><div class="d-flex justify-content-center">{{$t("param_lamp." + lamp.lssa).toUpperCase()}}</div></strong>
                                        </td>  
                                        <td v-if="props.row.cu_type.startsWith('logica') && lamp.emer_active=='EMERGENZA IN CORSO'">
                                            <div class="d-flex justify-content-center mb-2">Emergenza in corso</div>
                                            <i class="fa fa-2x fa fa-exclamation-circle mr-2 emergency-on" /> 
                                        </td>  
                                        <td v-else>
                                            <i class="fa fa-2x" v-bind:class="[dotClassLamp(lamp)]" /> 
                                        </td> 
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </v-client-table>
                    </b-check-group>   
                    </hide-at>


                <!-- Visualizzazione mobile ---->
                    <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
                        <div style="margin-top: 124px">
                            <b-row style="position: fixed; top: 144px; left: 8px; right: 8px; z-index: 1; background-color: #eee">
                                <b-col class="my-2">
                                    <b-input-group>
                                        <b-form-input type="text" placeholder="Cerca" v-model="filters.search"></b-form-input>
                                        <!-- Attach Right button -->
                                        <b-input-group-append>
                                            <b-button variant="primary" @click="filtra()"><i class="fa fa-search"></i> </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                            <b-check-group id="righeSel" v-model="righeSel">
                        <b-nav class="mobile-sub-nav" style="background: #eee; padding-left: 16px; position: fixed; top: 194px; left: 8px; right: 8px; z-index: 1" v-if="$store.getters.userRole =='installer' || $store.getters.userRole =='collab'">
                        
                            <b-nav-text>
                                <b-checkbox @change="toggleSeleziona()" id="allSelect" value="x" >{{$t("select_checkbox.text")}}</b-checkbox>
                            </b-nav-text>
                            <!--<b-button size="sm" v-b-toggle.commands-collapse>Azioni</b-button>-->
                            <b-dropdown id="dd-azioni-menu" right  >
                                <template v-slot:button-content>
                                <span>Azioni</span>
                                </template>
                                <!--<b-dropdown-item>
                                        <add-central-unit id="add-central-unit-button"> </add-central-unit>
                                        <remove-central-unit id="remove-central-unit-button"> </remove-central-unit>
                                </b-dropdown-item>
                                -->
                                    
                                <b-dropdown-item @click="sendGenericCommand('test_funzionale')">{{$t('command.test_funzionale')}}</b-dropdown-item>
                                <b-dropdown-item @click="sendGenericCommand('test_autonomia')">{{$t('command.test_autonomia')}}</b-dropdown-item>
                                <b-dropdown-item @click="sendGenericCommand('stop_test')">{{$t('command.stop_test')}}</b-dropdown-item>                          
                                <b-dropdown-item @click="sendGenericCommand('rest_mode')">{{$t('command.rest_mode')}}</b-dropdown-item>
                                <b-dropdown-item @click="sendGenericCommand('refresh')">{{$t('command.refresh')}}</b-dropdown-item>
                                <b-dropdown-item @click="sendGenericCommand('stop_blink')">{{$t('command.stop_blink')}}</b-dropdown-item>
                                <b-dropdown-item>
                                    <parametri-impianto id="parametri-button2" :sendAction="sendGenericCommandMulti" :alerts="alerts" :lamp="lampadeSel" :cu="centraliSel" ></parametri-impianto>
                                    <pianifica-test id="pianifica-button2" :sendAction="sendPianificaTest" :alerts="alerts" :cu="centraliSel" :timezoneLocation="this.$store.state.timezoneLocation"></pianifica-test>
                                    <parametri-uvoxy :sendAction="sendGenericCommandMulti" :lamp="lampadeSel" :cu="centraliSel" :alerts="alerts" class="pull-right"></parametri-uvoxy>
                                </b-dropdown-item>
                            </b-dropdown>
                            <b-dropdown id="dd-comandi-menu" right no-caret >
                                <template v-slot:button-content>
                                <span>+</span>
                                </template>
                                <b-dropdown-item>
                                        <add-central-unit id="add-central-unit-button"> </add-central-unit>
                                        <remove-central-unit id="remove-central-unit-button"> </remove-central-unit>
                                </b-dropdown-item>
                                
                            </b-dropdown>
                            
                        </b-nav>
                        <b-collapse id="commands-collapse">
                        <b-row>
                            <b-col cols="6" class="text-center">
                                <b-dropdown  id="test_command" class="typo-label mr-1 ml-1 mt-3">
                                <template slot="button-content">
                                    <i class="fa fa-bolt"></i>
                                    <span class="ml-2 mr-2 typo-label">{{$t("command_button.test")}}</span>
                                </template>
                                <b-dropdown-item @click="sendGenericCommand('test_funzionale')">{{$t('command.test_funzionale')}}</b-dropdown-item>
                                <b-dropdown-item @click="sendGenericCommand('test_autonomia')">{{$t('command.test_autonomia')}}</b-dropdown-item>
                                <b-dropdown-item @click="sendGenericCommand('stop_test')">{{$t('command.stop_test')}}</b-dropdown-item>
                                </b-dropdown>
                            </b-col>
                            <b-col cols="6" class="text-center">
                                <b-dropdown  id="generic_command" text="Comandi" class="typo-label mr-1 ml-1 mt-3">
                                    <template slot="button-content">
                                        <i class="fa fa-paper-plane"></i>
                                        <span class="ml-2 mr-2 typo-label">{{$t("command_button.command")}}</span>
                                    </template>
                                    <b-dropdown-item @click="sendGenericCommand('rest_mode')">{{$t('command.rest_mode')}}</b-dropdown-item>
                                    <b-dropdown-item @click="sendGenericCommand('refresh')">{{$t('command.refresh')}}</b-dropdown-item>
                                    <b-dropdown-item @click="sendGenericCommand('stop_blink')">{{$t('command.stop_blink')}}</b-dropdown-item>
                                </b-dropdown>
                            </b-col>
                            <b-col cols="6" class="text-center">
                                <parametri-impianto :sendAction="sendGenericCommandMulti" :alerts="alerts" :lamp="lampadeSel" :cu="centraliSel" ></parametri-impianto>
                            </b-col>
                            <b-col cols="6" class="text-center">
                                 <pianifica-test :sendAction="sendPianificaTest" :alerts="alerts" :cu="centraliSel" :timezoneLocation="this.$store.state.timezoneLocation"></pianifica-test>
                            </b-col>
                        </b-row>
                    </b-collapse>

                        <!-- tabella dispositivi small , mobile-->                         
                        <table id="tabDispositiviSmall" class="table table-condensed">
                            <tbody>
                                <tr v-for="(cent,centIndex) in tableData" v-bind:key="cent.cu_id">
                                    <td><b-card no-body>
                                        
                                            <b-row>
                                                <b-col cols="1" class="nopadding">
                                                    <b-checkbox :disabled="!cent.enabled" @click.native="toggleCentCheckbox" :value="'cent-'+(centIndex)" :id="'cent-'+cent.cu_id" />
                                                </b-col>
                                                <b-col cols="2" class="nopadding">
                                                    <img  :src="'/img/'+cent.cu_type+'/centrale_small.png'" style="height:auto; width:80%"/>
                                                </b-col>
                                                <b-col cols="8">
                                                    <h4>{{cent.cu_desc}}</h4>
                                                    <h5>{{$t("central_unit")}} {{cent.cu_type}}</h5>
                                                    <div class="centStatus">
                                                    <i class="fa fa-circle" v-bind:class="[onlineClass(cent)]" /> {{ descrStato(cent) }}
                                                    </div>

                                                </b-col>
                                                <b-col cols="1" class="nopadding">
                                                    <b-dropdown v-if="cent.enabled" variant="link" size="lg" toggle-class="text-decoration-none" no-caret right>
                                                        <template slot="button-content">
                                                            <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                                        </template>
                                                        <b-dropdown-item @click="showCentDetails(cent)">{{$t("cu_table_row.dropdown_dettaglio")}}</b-dropdown-item>
                                                        <b-dropdown-item v-if="$store.getters.userRole == 'installer' || $store.getters.userRole == 'collab'" @click="showConfigCent(cent)">{{$t("cu_table_row.dropdown_configura")}}</b-dropdown-item>
                                                        <b-dropdown-item v-if="$store.getters.userRole == 'installer' || $store.getters.userRole == 'collab'" @click="showRemoveCu(cent)">{{$t("remove_cu_button.text")}}</b-dropdown-item>
                                                        <b-dropdown-item v-if="cent.cu_type=='logica' && cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')" @click="showGroups(cent)">{{$t("lamp_details_modal.groups")}}</b-dropdown-item>
                                                        <b-dropdown-item v-if="cent.cu_type=='logicafm' && cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')" @click="showGroups(cent)">{{$t("lamp_details_modal.groups")}}</b-dropdown-item>
                                                        <b-dropdown-item v-if="cent.cu_type=='logicafm' && cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')" @click="showAdvanced(cent)">{{$t("lamp_details_modal.advanced")}}</b-dropdown-item>
                                                    </b-dropdown>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col offset="3">
                                                    <i v-if=" (working(cent) && cent.cu_connected)" class="fa fa-spinner fa-spin" />
                                                    <div v-if="testactive(cent)" style="display: inline; margin-left: 8px"> 
                                                        <i class="fa fa-battery-three-quarters" style="color:orange"></i> <div class="typo-icon" style="display:inline">{{$t("param_lamp.TEST IN CORSO")}}</div>   
                                                    </div>
                                                    <div v-if="restmodeactive(cent)" style="display: inline; margin-left: 8px"> 
                                                        <i class="fa fa-caret-square-o-down" style="color:orange"></i><div class="typo-icon" style="display:inline; margin-left: 8px">{{$t("param_lamp.REST MODE ACTIVATED")}}</div>   
                                                    </div>  
                                                    <!-- <div v-if="emergencyactive(cent)">
                                                        <i class="fa fa-2x fa fa-exclamation-circle mr-2 emergency-on"></i> 
                                                   </div>  -->
                                                </b-col>
                                            </b-row>
                                            <b-row class="mt-2">
                                                <b-col cols="5" offset="1" class="dataLabels">
                                                    {{$t("id_cu")}}
                                                </b-col>
                                                <b-col cols="5" class="dataValues">
                                                    {{cent.cu_id}}
                                                </b-col>
                                                <b-col cols="1">
                                                    <b-button size="sm" v-if="cent.enabled" > <i class="fa fa-angle-right" @click="toggleLamps(cent.cu_id)" /> </b-button>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col cols="5" offset="1" class="dataLabels">
                                                    {{$t("lamps_found")}}
                                                </b-col>
                                                <b-col cols="5" class="dataValues">
                                                    {{cent.lamps.length}}
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col cols="5" offset="1" class="dataLabels">
                                                    {{$t("details_lamp.lamp_state")}}
                                                </b-col>
                                                <b-col cols="5" class="dataValues">
                                                    <i class="fa " v-bind:class="[dotClass(cent)]" /> 
                                                </b-col>
                                            </b-row>
                                            
                                            <b-collapse v-if="cent.enabled" :id="'collapse-'+cent.cu_id" class="mt-2">
                                                <b-card v-for="(lamp,lampindex) in cent.lamps" v-bind:key="lamp.id" class="lampCard" no-body>
                                                    <b-row>
                                                        <b-col cols="1" class="nopadding">
                                                            <b-checkbox :disabled="!cent.enabled || centraliSel.length > 0" :value="'lamp-'+(centIndex)+'-'+lampindex" :id="'lamp-'+(centIndex)+'-' + lampindex" />
                                                        </b-col>
                                                        <b-col cols="2" class="nopadding">
                                                            <img :src="'/img/apparecchi/' + lamp.product_image" style="height:auto; width:100%;" />
                                                        </b-col>
                                                        <b-col cols="8">
                                                            <h4>{{lamp.desc}}<br/>{{lamp.product_desc}}</h4>
                                                            <h5>ID: {{lamp.id}} <span style="padding-left: 20px">cod. {{lamp.product_code}}</span>
                                                                <img v-if="lamp.lamp_type=='SA'" src="/img/SA.png" class="icon-lamp-type"></img>
                                                                <img v-if="lamp.lamp_type=='SE'" src="/img/SE.png" class="icon-lamp-type"></img>
                                                                 <img v-if="lamp.fan_sanifica && lamp.fan_sanifica!='--'" src="/img/uvoxyIcon.png" class="icon-lamp-type"></img>
                                                            </h5>
                                                        </b-col>
                                                        <b-col cols="1" class="nopadding">
                                                            <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none" no-caret right>
                                                                <template slot="button-content">
                                                                    <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                                                </template>
                                                                <b-dropdown-item @click="showLampDetails(cent,lamp)">{{$t("cu_table_row.dropdown_dettaglio")}}</b-dropdown-item>
                                                                <div class="dropdown-divider" v-if="cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && cent.cu_type!='logica'"></div>
                                                                <b-dropdown-item @click="showLampBlink(cent,lamp)" v-if="cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && cent.cu_type!='logica'">{{$t("cu_table_row.dropdown_blink")}}</b-dropdown-item>
                                                            </b-dropdown>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col cols="5" offset="1" class="dataLabels">
                                                            {{$t("id_cu")}}
                                                        </b-col>
                                                        <b-col cols="5" class="dataValues">
                                                            {{cent.cu_id}}
                                                        </b-col>
                                                        <b-col cols="1">
                                                            <i class="fa" v-bind:class="[dotClassLamp(lamp)]" /> 
                                                        </b-col>
                                                    </b-row>
                                                    <b-row v-if="lamp.lamp_type!='SE'">
                                                         <b-col cols="5" offset="1" class="dataLabels">
                                                            {{$t("details_lamp.lamp_sa_dimming")}}
                                                         </b-col>
                                                         <b-col cols="6">                                                             
                                                            <strong><div v-if="lamp.lamp_type!='SE' && lamp.shadow_pending" v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('sa_dimming'))]">
                                                            {{lamp.sa_dimming}}
                                                            <i v-if="lamp.sa_dimming!='SE' && lamp.sa_presence=='SA PRESENTE'" class="fas fa-lightbulb" style="color:gold"></i>
                                                            <i v-if="lamp.sa_dimming!='SE' && lamp.sa_presence=='SA NON PRESENTE'" class="far fa-lightbulb" style="color:black"></i>
                                                           </div></strong>     
                                                          </b-col> 
                                                    </b-row>
                                                    <b-row>
                                                        <b-col cols="5" offset="1" class="dataLabels">
                                                            {{$t("details_lamp.lamp_autonomy")}}
                                                        </b-col>
                                                        <b-col cols="6">
                                                            <strong v-if="lamp.shadow_pending" v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('autonomy'))]"><div>{{lamp.autonomy}}</div></strong>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col cols="5" offset="1" class="dataLabels">
                                                            {{$t("details_lamp.lamp_parity")}}
                                                        </b-col>
                                                        <b-col cols="6">
                                                          <strong v-if="lamp.shadow_pending" v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('parity'))]"><div>{{$t("param_lamp." + lamp.parity ).toUpperCase()}}</div></strong>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row v-if="lamp.lssa && !cent.cu_type.startsWith('logica')">
                                                        <b-col cols="5" offset="1" class="dataLabels">
                                                            {{$t("details_lamp.lamp_infinity")}}
                                                        </b-col>
                                                        <b-col cols="6" >
                                                            <strong v-if="lamp.shadow_pending" v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('lssa'))]"><div>{{$t("param_lamp." + lamp.lssa).toUpperCase()}}</div></strong>
                                                        </b-col>
                                                    </b-row> 
                                                    <b-row v-if="lamp.fan_sanifica && lamp.fan_sanifica!='--'">
                                                        <b-col cols="5" offset="1" class="dataLabels">
                                                            {{$t("details_lamp.lamp_sanifica")}}
                                                        </b-col>
                                                        <b-col cols="6" >
                                                            <strong v-if="lamp.shadow_pending" v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('lamp.tuboUV_fase_sanifica'))]"><div>{{lamp.tuboUV_fase_sanifica.toUpperCase()}}</div></strong>
                                                        </b-col>
                                                    </b-row>
                                                </b-card>
                                            </b-collapse>
                                        
                                    </b-card></td>
                                </tr>
                            </tbody>
                        </table>
                            </b-check-group>
                        </div>
                    </show-at>
                </b-col>
            </b-row>
        </div>

        <!-- Dettaglio Centrale -->
        <b-modal v-if="currentCent != null" id="dett-cent-modal" no-close-on-backdrop :title="$t('unit_details_modal.title', {tipo: currentCent.cu_type, id: currentCent.cu_id})" :ok-only="true" :ok-title="$t('close')" @ok="closeCentDetails">
            <b-container fluid>
            <b-row>
                <b-col cols="4" class="my-auto text-center"><img  :src="'/img/' + currentCent.cu_type +'/centrale.png'" style="height:60px; width:auto;" /></b-col>
                <b-col cols="8">
                    <b-row>
                        <b-col cols="6">
                            <b-row><b-col cols="12">{{$t("details_cu_modal.cu_type")}}</b-col></b-row>
                            <b-row><b-col cols="12"><strong>{{currentCent.cu_type}}</strong></b-col></b-row>
                        </b-col>
                        <b-col cols="6">
                            <b-row><b-col cols="12">{{$t("details_cu_modal.cu_id")}}</b-col></b-row>
                            <b-row><b-col cols="12"><strong>{{currentCent.cu_id}}</strong></b-col></b-row>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col cols="12">
                            <b-row><b-col cols="12">{{$t("details_cu_modal.cu_descrizione")}}</b-col></b-row>
                            <b-row>
                                <b-col v-if="!editingCent" cols="10"><strong>{{currentCent.cu_desc}}</strong></b-col>
                                <b-col v-if="!editingCent" cols="2"><b-button @click="editNomeCent"><i class="fa fa-edit"></i></b-button></b-col>
                                <b-col v-if="editingCent" cols="8">
                                    <div role="group">
                                    <b-form-input id="centName" type="text" v-model="nomeCent"></b-form-input>
                                    <b-form-text v-html="centNameInfo"></b-form-text>
                                    </div>
                                </b-col>
                                <b-col v-if="editingCent" cols="4">
                                    <b-button v-if="!updatingName" @click="saveNomeCent"><i class="fa fa-check"></i></b-button>
                                    <b-button v-if="!updatingName" @click="abortNomeCent" ><i class="fa fa-close"></i></b-button>
                                    <span v-if="updatingName"><i class="fa fa-spinner fa-spin"></i></span>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            </b-container>
            <hr>
            <b-container fluid v-if="currentCent.cu_error">
            <b-row > <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade")}} :</b-col><b-col cols="2" sm="5">{{currentCent.num_lamp_found}}</b-col></b-row>
            <b-row v-if="currentCent.num_lamp_present"> <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade_presenti")}} :</b-col><b-col cols="2" sm="5">{{currentCent.num_lamp_present}}</b-col></b-row>
            <b-row > <b-col cols="10" offset-sm="1" sm="6">{{$t("details_cu_modal.cu_numero_lampade_errore")}} :</b-col><b-col cols="2" sm="5">{{currentCent.num_lamp_error}}</b-col></b-row>
            <br>
            <b-row  v-if='currentCent.cu_status.emergency_running=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle emergency-on mr-2 mb-3"></i>{{$t("details_cu_modal.emergency_on")}}</b-col></b-row>
            <b-row ><b-col cols="12" offset-sm="1" sm="10"><strong>{{$t("details_cu_modal.cu_error")}}</strong></b-col></b-row>
            <b-row  v-if='currentCent.cu_error.error_batt_low_voltage=="ON" && currentCent.cu_error.error_batt_not_connected=="OFF"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_batt_low_voltage")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.error_batt_not_connected=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_batt_not_connected")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.error_duplicated_id_lamp=="ON"'><b-col scols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_duplicated_id_lamp")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.error_lg=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_lg")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.error_wiring=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_wiring")}}</b-col></b-row>            
            <b-row class="m-2" v-if='currentCent.cu_error.error_too_much_lamp_in_config=="ON"'><b-col sm="12"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_error_too_much_lamp_in_config")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.error_overload=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_overload")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.error_missing_lamp_in_config=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.cu_error_missing_lamp_in_config")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.error_more_32_lamp_in_config=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_more_32_lamp_in_config")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.error_more_128_lamp_in_config=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_more_128_lamp_in_config")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.err_data_invalid=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_date_time_invalid")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.err_UART1=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART1")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.err_UART2=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART2")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.err_UART3=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART3")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.err_UART3_modem_powerON=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_modem_off")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.err_UART4=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART4")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.err_UART5=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART5")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.err_UART6=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART6")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.err_UART7=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_UART7")}}</b-col></b-row>
            <b-row  v-if='currentCent.cu_error.mancanza_rete=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:orange"></i>{{$t("details_cu_modal.mancanza_rete")}}</b-col></b-row>

            
            <!-- cablecom -->
            <b-row  v-if='currentCent.cu_type=="cablecom" && currentCent.cu_error.error_batt_low_voltage=="OFF"
                                    && currentCent.cu_error.error_batt_not_connected=="OFF"
                                    && currentCent.cu_error.error_duplicated_id_lamp=="OFF"
                                    && currentCent.cu_error.error_lg=="OFF"
                                    && currentCent.cu_error.error_wiring=="OFF"
                                    && currentCent.cu_error.error_too_much_lamp_in_config=="OFF"
                                    && currentCent.cu_error.error_overload=="OFF"
                                    && currentCent.cu_error.error_missing_lamp_in_config=="OFF"
                                    && currentCent.cu_error.error_more_32_lamp_in_config=="OFF"'>
                <b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-check mr-2" style="color:green"></i>{{$t("details_cu_modal.cu_no_error")}}</b-col>
            </b-row>

            <!-- logica -->
            <b-row  v-if='currentCent.cu_type=="logica" && currentCent.cu_error.error_batt_low_voltage=="OFF"
                                    && currentCent.cu_error.error_batt_not_connected=="OFF"
                                    && currentCent.cu_error.error_duplicated_id_lamp=="OFF"
                                    && currentCent.cu_error.error_lg=="OFF"
                                    && currentCent.cu_error.error_wiring=="OFF"
                                    && currentCent.cu_error.error_too_much_lamp_in_config=="OFF"
                                    && currentCent.cu_error.error_overload=="OFF"
                                    && currentCent.cu_error.error_missing_lamp_in_config=="OFF"
                                    && currentCent.cu_error.error_more_128_lamp_in_config=="OFF"'>
                <b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-check mr-2" style="color:green"></i>{{$t("details_cu_modal.cu_no_error")}}</b-col>
            </b-row>

            <!-- logica fm -->
            <b-row  v-if='currentCent.cu_type=="logicafm" && currentCent.cu_error.err_data_invalid=="OFF"
                                    && currentCent.cu_error.err_UART1=="OFF"
                                    && currentCent.cu_error.err_UART2=="OFF"
                                    && currentCent.cu_error.err_UART3=="OFF"
                                    && currentCent.cu_error.err_UART3_modem_powerON=="OFF"
                                    && currentCent.cu_error.err_UART4=="OFF"
                                    && currentCent.cu_error.err_UART5=="OFF"
                                    && currentCent.cu_error.err_UART6=="OFF"
                                    && currentCent.cu_error.err_UART7=="OFF"
                                    && currentCent.cu_error.mancanza_rete=="OFF"'>
                <b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-check mr-2" style="color:green"></i>{{$t("details_cu_modal.cu_no_error")}}</b-col>
            </b-row>

            <hr>
            <b-row ><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{$t('pianifica_test_modal.title')}}</strong></b-col></b-row>
            <b-row> <b-col offset-sm="1"  sm="6">{{$t("details_cu_modal.cu_prossimo_test_funzionale")}} :</b-col><b-col  sm="4">{{moment(currentCent.cu_next_funct_test,).format('DD MMM YYYY - HH:mm')}} <p class="typo-littleblack">{{currentCent.cu_location}} </p> </b-col></b-row>
            <b-row > <b-col offset-sm="1" sm="6">{{$t("details_cu_modal.cu_prossimo_test_autonomia")}} :</b-col><b-col sm="4">{{moment(currentCent.cu_next_auto_test).format('DD MMM YYYY - HH:mm')}}  <p class="typo-littleblack">{{currentCent.cu_location}} </p> </b-col></b-row>
            <b-row > <b-col offset-sm="1" cols="9" sm="6">{{$t("details_cu_modal.cu_periodicita_test_funzionale")}} :</b-col><b-col cols="3" sm="5">{{currentCent.cu_period_funct_test}} gg</b-col></b-row>
            <b-row > <b-col offset-sm="1" cols="9" sm="6">{{$t("details_cu_modal.cu_periodicita_test_autonomia")}} :</b-col><b-col  cols="3" sm="5">{{currentCent.cu_period_auto_test}} gg</b-col></b-row>
            <b-row > <b-col offset-sm="1" cols="9" sm="6">{{$t("details_cu_modal.test_differito")}} :</b-col><b-col cols="3" sm="5">{{currentCent.cu_status.test_differito}}</b-col></b-row>
            <hr>
            <b-row ><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{$t("details_cu_modal.specifiche_tecniche")}}</strong></b-col></b-row>
            <b-row v-if="currentCent.timezone"><b-col offset-sm="1"  sm="6">Timezone: </b-col><b-col  sm="5">{{currentCent.timezone}}</b-col></b-row>
            <b-row> <b-col offset-sm="1"  sm="6">Fw version: </b-col><b-col  sm="5">{{currentCent.cu_sw_ver.cu_sw_id}} Build:{{currentCent.cu_sw_ver.cu_sw_build}}</b-col></b-row>
            <b-row v-if="currentCent.modwifi_sw_ver"><b-col offset-sm="1"  sm="6">WiFi Fw version: </b-col><b-col  sm="5">{{currentCent.modwifi_sw_ver.modwifi_sw_id}} Build:{{currentCent.modwifi_sw_ver.modwifi_sw_build}}</b-col></b-row>
            <b-row v-if="currentCent.ETH0_state"><b-col offset-sm="1"  sm="6">ETH0 state (Eth0 Hooked Server): </b-col><b-col  sm="5">{{currentCent.ETH0_state.ETH0_HOOKED_SERVER}}</b-col></b-row>
            <b-row v-if="currentCent.SIM_state"><b-col offset-sm="1"  sm="6">SIM state: </b-col><b-col  sm="5">{{currentCent.SIM_state}}</b-col></b-row>
            <b-row v-if="currentCent.GSM_Campo">
                <b-col offset-sm="1" sm="6"><div class="mt-3"> GSM Strenght: </div> </b-col>
                <b-col  sm="5">
                        <i class="icon__signal-strength mb-2 mt-2" v-bind:class="[GsmClass(currentCent.GSM_Campo)]">
                            <span class="bar-1"></span>
                            <span class="bar-2"></span>
                            <span class="bar-3"></span>
                            <span class="bar-4"></span>
                            <span class="bar-5"></span>
                        </i>
                </b-col>
            </b-row>
            <b-row v-if="currentCent.GSM_REG_state"><b-col offset-sm="1"  sm="6">GSM REG state: </b-col><b-col  sm="5">{{currentCent.GSM_REG_state}}</b-col></b-row>
            <hr>
            <b-row><b-col cols="12" offset-sm="1" sm="10" class="mb-1"><strong>{{$t("details_cu_modal.connessioni_cloud")}}</strong></b-col></b-row>
            <b-row v-if="currentCent.first_installation_timestamp"> <b-col offset-sm="1"  sm="6">{{$t("details_cu_modal.prima_installazione")}} </b-col><b-col  sm="5">{{moment(String(new Date(currentCent.first_installation_timestamp))).format('DD MMM YYYY - HH:mm')}} <p class="typo-littleblack">{{currentCent.cu_location}} </p></b-col></b-row>
            <b-row> <b-col offset-sm="1"  sm="6">{{$t("details_cu_modal.aggiornamento_dati")}} </b-col><b-col  sm="5">{{moment(String(new Date(currentCent.timestamp))).format('DD MMM YYYY - HH:mm')}}<p class="typo-littleblack">{{currentCent.cu_location}} </p></b-col></b-row>
         
          </b-container>
        </b-modal>

        <!-- Configura Centrale -->
        <b-modal v-if="currentCent != null" size="md" :hide-footer="configInProgress > 0 || configCompleted == true || delete_sn ==true" id="config-cent-modal" no-close-on-backdrop :hide-header-close="!headerClose" :title="$t('config_cu_modal.title', {tipo: currentCent.cu_type, id: currentCent.cu_id})" :ok-only="true" :ok-title="(this.selected_modalita_logica=='logica_delete')?$t('config_cu_modal.button_delete'):$t('config_cu_modal.button_config')" @ok="sendConfigCent($event,currentCent.cu_type,currentCent.cu_id)">
            <b-row>
                <b-col cols="3"><img  :src="'/img/' + currentCent.cu_type +'/centrale.png'" style="height:60px; width:auto" class="ml-3" /></b-col>
                <b-col cols="3"><b-row ><b-col>{{$t("details_cu_modal.cu_type")}}</b-col></b-row><b-row><b-col>{{currentCent.cu_type}}</b-col></b-row></b-col>
                <b-col cols="3"><b-row ><b-col>{{$t("details_cu_modal.cu_id")}}</b-col></b-row><b-row>{{currentCent.cu_id}}</b-row></b-col>
                <b-col cols="3"><b-row ><b-col>{{$t("details_cu_modal.cu_descrizione")}}</b-col></b-row><b-row>{{currentCent.cu_desc}}</b-row></b-col>
            </b-row>
            <hr>

            <!-- cablecom config lamp -->
            <b-row v-if="currentCent.cu_type=='cablecom'">
                <b-form-group class="ml-5 mt-4">
                    <label class="h6">{{$t("config_cu_modal.seleziona_numero_lampade")}}</label>
                    <b-form-select v-model="selected_num_lamp" :options="options_lamp">
                     
                    </b-form-select>
                </b-form-group>
                <b-form-group class="ml-5 mt-2 mb-5">
                    <label class="h6">{{$t("config_cu_modal.seleziona_ore_autonomia")}}</label>
                    <b-form-select v-model="selected_ore_autonomia" :options="options_ore_autonomia" ></b-form-select>
                </b-form-group>
            </b-row> 

            <!-- logica config lamp -->
            <b-row v-if="currentCent.cu_type=='logica' || currentCent.cu_type=='logicafm'">
                <b-form-group class="ml-4 mt-2 mb-4">
                    <label class="h6">{{$t("config_cu_modal.modalita_configurazione_logica")}}</label>
                        <b-row>
                        <b-col cols="12">
                            <b-form-select v-model="selected_modalita_logica" :options="options_modalita_logica"></b-form-select>
                        </b-col>
                        </b-row>

            <!-- logica inserimento serial number manualmente -->
                        <div v-if="selected_modalita_logica=='logica_preset'" class="mt-4 float-left ml-2 mr-4">
                            <label for="cu-list-device" class="typo-label mb-2">{{$t("config_cu_modal.logica_sn_list")}}</label>
                            <b-form-textarea
                                id="cu-list-device"
                                :disabled=true
                                v-model="logica_cu_list"
                                :state=true
                                rows="10">
                            </b-form-textarea>
                        </div>
                        <div v-if="selected_modalita_logica=='logica_preset'" class="mt-4 ml-3 float-left">
                            <label for="file-list-device" class="typo-label mb-2">{{$t("config_cu_modal.logica_sn_input")}}
                            <span class="infoTip" :content="$t('config_cu_modal.logica_sn_input_info')" v-tippy="{ placement : 'top',  arrow: true}"> <i class="fa fa-1x fa-info-circle" style="color:#009DE0" ></i></span>
                            </label>
                            <b-form-textarea
                                id="file-list-device"
                                v-model="logica_config_sn"
                                placeholder=""
                                rows="10">
                            </b-form-textarea>
                        </div>
                </b-form-group>
            </b-row> 
             
            

            <b-row v-if="selected_modalita_logica=='logica_preset'">
                <b-col cols="12">
                    <b-form-group  class="ml-4 float-left typo-label" :label='$t("config_cu_modal.modalita_inserimento")' v-slot="{ ariaDescribedby }">
                        <b-form-radio v-model="manual_mode_logica" :aria-describedby="ariaDescribedby" name="some-radios" value="append">{{$t("config_cu_modal.modalita_append")}}</b-form-radio>
                        <b-form-radio v-model="manual_mode_logica" :aria-describedby="ariaDescribedby" name="some-radios" value="overwrite">{{$t("config_cu_modal.modalita_overwrite")}}</b-form-radio>
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- logica cancellazione serial number -->
            <div v-if="selected_modalita_logica=='logica_deletexxx'" class="mt-1 ml-3 mr-3">
                            <label for="cu-list-device" class="typo-label mb-2">{{$t("config_cu_modal.logica_sn_list")}}</label>
                            <b-form-textarea
                                id="cu-list-device"
                                :disabled=true
                                v-model="logica_cu_list"
                                :state="logica_cu_list.length >= 0"
                                rows="10">
                            </b-form-textarea>
                            <b-alert v-if="this.delete_sn" variant="danger" class="mt-4" show>
                                <i class="fa fa-1x fa-exclamation-circle mr-2"></i>
                                {{$t("config_cu_modal.logica_sn_delete")}}
                                <b-button variant="primary" class="mt-4 float-right" @click="function(){delete_sn=false}">No</b-button>
                                <b-button variant="primary" class="mt-4 mr-3 float-right" @click="sendDeleteLogicaSerialId(currentCent.cu_type,currentCent.cu_id)">Sì</b-button>
                            </b-alert>
            </div>
            
            <!-- logica sostituzione serial number -->
            <div v-if="selected_modalita_logica=='logica_substitute' || selected_modalita_logica=='logica_delete'" class="float-left ml-2 mr-4">
                <label for="cu-list-device" class="typo-label mb-2" >{{$t("config_cu_modal.logica_sn_list")}} </label>
                <b-form-checkbox v-if="selected_modalita_logica=='logica_delete'" v-model="deleteAllLamps" @change="substituteLampsSelection = []">Elimina tutti i dispositivi</b-form-checkbox>
                <div style="border: 1px solid #ddd; overflow-y: auto; height: 240px; width: 120px; padding-left: 8px; margin-bottom: 8px;">
                    <b-form-checkbox-group 
                        id="lamp_selection_group"
                        v-model="substituteLampsSelection"
                        :options="currentCent.lamps_id"
                        :disabled="deleteAllLamps"
                        stacked
                    >
                    </b-form-checkbox-group>
                </div>
            </div>
            <div v-if="selected_modalita_logica=='logica_substitute'" class="ml-3 float-left">
                <label for="file-list-device" class="typo-label mb-2">{{$t("config_cu_modal.logica_sn_input")}}
                <span class="infoTip" :content="$t('config_cu_modal.logica_sn_input_info')" v-tippy="{ placement : 'top',  arrow: true}"> <i class="fa fa-1x fa-info-circle" style="color:#009DE0" ></i></span>
                </label>
                <b-form-textarea style="height:240px; width: 140px; position: absolute; float: right; margin-left: 59px; font-size: 11pt; padding-top: 6px"
                    id="file-list-device"
                    v-model="logica_config_sn"
                    
                    placeholder="--"
                    rows="10">
                </b-form-textarea>
                <div style="width: 60px; height:240px; border: 1px solid #ddd; padding-top: 6px; font-size: 11pt;">
                    <span v-for="(lampId,index) in substituteLampsSelection" style="display:block; padding-left: 8px;">{{lampId}}</span>
                </div>   
            </div>
            <div v-if="selected_modalita_logica=='logica_delete'" class="ml-3 float-left" >
                <label for="file-list-device" class="typo-label mb-2">{{$t("config_cu_modal.logica_sn_delete_list")}}
                </label>
                <div style="width: 120px; height:240px; border: 1px solid #ddd; padding-top: 6px; font-size: 11pt; margin-top: 20px;">
                    <span v-for="(lampId,index) in substituteLampsSelection" style="display:block; padding-left: 8px;">{{lampId}}</span>
                </div>   
            </div>

            <b-alert v-if="this.delete_sn" variant="danger" show style="clear: both;">
                <i class="fa fa-1x fa-exclamation-circle mr-2"></i>
                {{$t("config_cu_modal.logica_sn_delete_multi_alert")}}
                <div class="text-right">
                <b-button variant="primary" class="mr-4" @click="function(){delete_sn=false}">No</b-button>
                <b-button variant="primary" class="" @click="sendDeleteMultiLogicaSerialId(currentCent.cu_type,currentCent.cu_id)">Sì</b-button>
                </div>
            </b-alert>

            <!-- alert per errore in caso di inserimento serial ID lampade -->
            <b-row v-if="selected_modalita_logica=='logica_preset' || selected_modalita_logica=='logica_substitute' || selected_modalita_logica=='logica_delete'" class="alert-feeback-command" style="clear: both;">  
                    <b-col lg="12" md="12">
                    <b-alert v-for="(alert,indexA) in validation_alerts" :show="alert.timeLeft" v-bind:key="indexA" :variant="alert.state"
                                dismissible
                                fade
                                @dismissed="alert.timeLeft=0"
                                @dismiss-count-down="alert.countDownChanged">
                                <div>
                                <i v-if="alert.state=='danger'" class="fa fa-1x fa-exclamation-circle mr-2"></i>
                                <i v-if="alert.state=='success'" class="fa fa-1x fa-check-circle mr-2"></i>
                                <div class="pb-3" style="display:inline; font-size:13px; height:15px;">{{alert.msg}}</div></div>
                    </b-alert>
                    </b-col>
            </b-row>

            <b-row v-if="configInProgress > 0">
                <b-col sm="3" class="mx-right">
                    <div class="sk-circle mx-right">
                        <div class="sk-circle1 sk-child"></div>
                        <div class="sk-circle2 sk-child"></div>
                        <div class="sk-circle3 sk-child"></div>
                        <div class="sk-circle4 sk-child"></div>
                        <div class="sk-circle5 sk-child"></div>
                        <div class="sk-circle6 sk-child"></div>
                        <div class="sk-circle7 sk-child"></div>
                        <div class="sk-circle8 sk-child"></div>
                        <div class="sk-circle9 sk-child"></div>
                        <div class="sk-circle10 sk-child"></div>
                        <div class="sk-circle11 sk-child"></div>
                        <div class="sk-circle12 sk-child"></div>
                    </div>
                </b-col>
                <b-col sm="9" class="my-auto mx-left">
                    <h5 v-html="$tc('config_cu_modal.config_in_corso',lamp_found)"></h5>
                </b-col>
            </b-row>

            <b-row v-if="configError == true">
                <b-col offset="1" sm="8">
                    <div class="text-center"><i class="fa fa-4x fa-exclamation-triangle" style="color:orange" aria-hidden="true"></i></div>
                    <div class="text-center mt-3 mb-3">{{$t("config_cu_modal.config_lamp_impostate", {selected_num_lamp: selected_num_lamp, lamp_found: lamp_found })}}</div>
                </b-col>
            </b-row>

            <b-row  v-if="configError == false && configCompleted == true">
                <b-col offset="1" sm="10">
                <div class="text-center"><i class="fa fa-4x fa-check" style="color:green" aria-hidden="true"></i></div>
                <div class="text-center h5 mt-2 mb-4" v-html="$tc('config_cu_modal.config_completed', lamp_found)"></div>
                </b-col>
            </b-row>
            
        </b-modal>

        <!-- Dettaglio Lampada -->              
        <b-modal v-if="currentLamp != null" id="dett-lamp-modal" no-close-on-backdrop :title="$t('lamp_details_modal.title', {id: currentLamp.id})" :ok-only="true" :ok-title="$t('close')" @ok="closeLampDetails">
            <b-row>
                <b-col cols="12" sm="4"><img  v-if="currentLamp.product_image" class="ml-4"  :src="'/img/apparecchi/' + currentLamp.product_image" style="height:80px; width:auto; float: left; margin-right: 10px" /></b-col>
                <b-col v-if="currentLamp.product_desc" cols="8" offset="1" offset-sm="0" sm="6"><b-row><b-col>{{$t("details_lamp.lamp_prod_desc")}}</b-col></b-row><b-row><b-col><strong>{{currentLamp.product_desc}}</strong></b-col></b-row></b-col> 
                <b-col cols="3" sm="2"><b-row><b-col>{{$t("details_lamp.lamp_id")}}</b-col></b-row><b-row><b-col><strong>{{currentLamp.id}}</strong></b-col></b-row></b-col>    
            </b-row>
            
            <b-row class="mt-2">
                <b-col cols="11" offset="1" sm="8" offset-sm="4">
                    <b-row>
                        <b-col>{{$t("details_lamp.lamp_desc")}}</b-col>
                    </b-row>
                    <b-row>
                        <b-col v-if="!editingLamp" cols="9" sm="10"><strong>{{currentLamp.desc}}</strong></b-col>
                        <b-col v-if="!editingLamp" cols="3" sm="2"><b-button @click="editNomeLamp"><i class="fa fa-edit"></i></b-button></b-col>
                        <b-col v-if="editingLamp" cols="7" sm="8">
                                    <div role="group">
                                    
                                        <b-form-input id="lampName" type="text" v-model="nomeLamp" :maxlength="maxchar"></b-form-input>
                                        <b-form-text v-html="lampNameInfo"></b-form-text>
                                    </div>
                        </b-col>
                        <b-col v-if="editingLamp" cols="5" sm="4">
                                    <b-button v-if="!updatingName" @click="saveNomeLamp"><i class="fa fa-check"></i></b-button>
                                    <b-button v-if="!updatingName" @click="abortNomeLamp" ><i class="fa fa-close"></i></b-button>
                                    <span v-if="updatingName"><i class="fa fa-spinner fa-spin"></i></span>
                        </b-col>
                    </b-row>
                </b-col>
                
            </b-row>
            <div v-if="currentLamp.fan_sanifica && currentLamp.fan_sanifica!='--'">
                <hr>
                <b-row class="m-2"><b-col sm="12"><strong>Parametri di sanificazione</strong></b-col></b-row>
                <b-row class="m-2"><b-col cols="4" sm="4">Sanificazione :</b-col><b-col cols="4" sm="4">ON</b-col></b-row>  
                <b-row class="m-2"><b-col cols="4" sm="4">Ventola :</b-col><b-col cols="4" sm="4">Media</b-col></b-row>
                <b-row class="m-2"><b-col cols="4" sm="4">Profilo :</b-col><b-col cols="4" sm="4">Sempre accesa</b-col></b-row>  
                <b-card>
                    <b-row>
                    <b-col cols="5" sm="5">
                        <img  :src="'/img/ricambi/cartuccia_uvoxy.png'" style="height:80px" class="ml-5 mt-3">
                    </b-col>    
                    <b-col cols="7" sm="7">
                        <h2 class="mt-3" v-bind:style="{'color':'green'}">70%</h2><p>Sostituisci tra 600 ore</p></span>
                        <div>
                            <p class="typo-color-label">Cartuccia UV-Oxy</p>
                            <p>Codice prodotto: 26720</p>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <b-input-group>
                            <b-form-input type="text" v-model="qrScanned" placeholder="Inserisci codice QR del ricambio"></b-form-input>
                            <b-input-group-append>
                                <b-button variant="primary" @click="startScan">Scansiona QR sul ricambio</b-button>
                            </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <b-button v-if="qrScanned.length > 6 && !scanning && !replacingCovidLamp" variant="success" @click="replaceCovidLamp">Conferma Sostituzione</b-button>
                        <i v-if="replacingCovidLamp" class="fa fa-spinner fa-spin" />
                        <qrcode-stream v-if="scanning || scannerInitialized" @decode="onDecode" @init="onInit" v-bind:style="{height: '300px',display: (scanning)?'block':'none'}"></qrcode-stream>
                    </b-col>
                </b-row>
                </b-card> 
            </div>             
            <div v-if="!scanning">
            <hr>
            <b-row class="m-2"><b-col sm="12"><strong>{{$t("details_lamp.lamp_param")}}</strong></b-col></b-row>
            <b-row class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_autonomy")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.autonomy}}</b-col></b-row>
            <b-row class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_parity")}} :</b-col><b-col cols="6" sm="4">{{$t("param_lamp."+currentLamp.parity)}}</b-col></b-row>
            <b-row class="m-2" v-if="currentLamp.lssa && !currentCent.cu_type.startsWith('logica')"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_infinity")}} :</b-col><b-col cols="6" sm="4">{{$t("param_lamp."+currentLamp.lssa)}}</b-col></b-row>
            <b-row class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_type")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.lamp_type}}</b-col></b-row>
            <hr>
            <b-row class="m-2"><b-col sm="12"><strong>{{$t("details_lamp.lamp_details")}}</strong></b-col></b-row>
            <b-row v-if="currentLamp.product_code" class="m-2"><b-col  cols="6" sm="5">{{$t("details_lamp.lamp_code")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.product_code}}</b-col></b-row>
            <b-row v-if="currentLamp.order_code" class="m-2"><b-col cols="6" sm="5">{{$t("details_lamp.lamp_order_code")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.order_code}}</b-col></b-row>
            <b-row v-if="currentLamp.battery_desc" class="m-2"><b-col cols="6" sm="5">{{$t("details_lamp.battery_desc")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.battery_desc}}</b-col></b-row>
            <b-row v-if="currentLamp.battery_code" class="m-2"><b-col cols="6" sm="5">{{$t("details_lamp.battery_code")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.battery_code}}</b-col></b-row>
            <b-row v-if="currentLamp.tube_desc" class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.tube_desc")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.tube_desc}}</b-col></b-row>
            <b-row v-if="currentLamp.tube_code" class="m-2"><b-col  cols="6" sm="5">{{$t("details_lamp.tube_code")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.tube_code}}</b-col></b-row>
            <b-row v-if="currentLamp.uvoxy_desc" class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.uvoxy_desc")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.uvoxy_desc}}</b-col></b-row>
            <b-row v-if="currentLamp.uvoxy_code" class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.uvoxy_code")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.uvoxy_code}}</b-col></b-row>
            <b-row v-if="currentLamp.device_type" class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.device_type")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.device_type}}</b-col></b-row>        
            <b-row class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_sw")}} :</b-col><b-col cols="6" sm="4">{{currentLamp.sw_ver}} <span v-if="currentLamp.sw_build!='nd'">(build: {{currentLamp.sw_build}})</span></b-col></b-row>
            <hr>
            <b-row class="m-2"><b-col sm="12"><strong>{{$t("details_lamp.lamp_state")}}</strong></b-col></b-row>
            <b-row class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_battery_state")}} :</b-col><b-col cols="6" sm="7">{{$t("param_lamp."+currentLamp.battery_state)}}</b-col></b-row>
            <b-row class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_test_duration")}} :</b-col><b-col cols="6" sm="7">{{currentLamp.test_duration}}</b-col></b-row>
            <b-row class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_se")}} :</b-col><b-col cols="6" sm="4">{{$t("param_lamp."+currentLamp.emer_active)}}</b-col></b-row>
            <b-row v-if="currentLamp.lamp_type!='SE'" class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_sa")}} :</b-col><b-col cols="6" sm="4">{{$t("param_lamp."+currentLamp.sa_presence)}}</b-col></b-row>
            <b-row v-if="currentLamp.lamp_type!='SE'" class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_sa_dimming")}} :</b-col><b-col cols="6" sm="7">{{$t("param_lamp."+currentLamp.sa_dimming)}}</b-col></b-row>
            <b-row class="m-2"> <b-col cols="6" sm="5">{{$t("details_lamp.lamp_test_active")}} :</b-col><b-col cols="6" sm="7">{{$t("param_lamp."+currentLamp.test_active)}}</b-col></b-row>
            <hr>
            <b-row v-if="currentLamp.groups" class="m-2">
                <b-col sm="12"><strong>{{$t("details_lamp.groups")}}</strong></b-col>
                <b-col v-if="currentLamp.groups.length==0" sm="12"><span>{{$t("details_lamp.groups_none")}}</span></b-col>
                <b-col v-else sm="12">
                    <!-- <span v-if="currentLamp.shadow_pending.groups && currentLamp.shadow_pending.groups.length>0" v-for="(group,index) in currentLamp.groups" v-bind:key="index" v-bind:class="[shadowPendingClass(currentLamp.shadow_pending.groups.indexOf(group))]">
                        {{ group }} | 
                    </span> -->
                    <span v-for="(group,index) in currentLamp.groups" v-bind:key="index">
                        <span class="h6" v-bind:class="[shadowPendingClass(currentLamp.shadow_pending.indexOf('setgroup'))]"> {{ group }} </span> <span v-if="index<currentLamp.groups.length-1"> - </span>
                    </span>
                
                </b-col>
            </b-row>
            <hr>
            <b-row class="m-2"><b-col sm="12"><strong>{{$t("details_lamp.lamp_error")}}</strong></b-col></b-row>
            <b-row class="m-2" v-if='currentLamp.error_batt_short=="ON"'><b-col sm="12"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_lamp.lamp_error_batt_short")}}</b-col></b-row>
            <b-row class="m-2" v-if='currentLamp.error_batt_test=="ON"'><b-col sm="12"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_lamp.lamp_error_batt_test")}}</b-col></b-row>
            <b-row class="m-2" v-if='currentLamp.error_com=="ON"'><b-col sm="12"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_lamp.lamp_error_com")}}</b-col></b-row>
            <b-row class="m-2" v-if='currentLamp.error_led=="ON"'><b-col sm="12"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_lamp.lamp_error_led")}}</b-col></b-row>
            <b-row class="m-2" v-if='currentLamp.error_hardware=="ON"'><b-col sm="12"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_lamp.lamp_error_hardware")}}</b-col></b-row>
            <b-row class="m-2" v-if='currentLamp.error_batt_short=="OFF"
                                    && currentLamp.error_batt_test=="OFF"
                                    && currentLamp.error_com=="OFF"
                                    && currentLamp.error_led=="OFF"
                                    && currentLamp.error_hardware=="OFF"'>
                                    <b-col sm="12"><i class="fa fa-check mr-2" style="color:green"></i>{{$t("details_lamp.lamp_no_error")}}</b-col>
            </b-row>
            </div>
        </b-modal>

         <!-- Blink Lampada -->              
        <b-modal v-if="currentLamp != null" id="blink-lamp-modal" no-close-on-backdrop hide-header-close :title="$t('lamp_details_modal.blink', {id: currentLamp.id})" :ok-only="true" :ok-title="$t('close')" @ok="closeLampBlink">
            <b-row>
                <b-col sm="3" class="ml-4"><img  :src="'/img/apparecchi/' + currentLamp.product_image" style="height:30px; width:auto; float: left; margin-right: 10px" /></b-col>
                <b-col sm="6"><b-row><b-col>{{$t("details_lamp.lamp_prod_desc")}}</b-col></b-row><b-row><b-col><strong>{{currentLamp.product_desc}}</strong></b-col></b-row></b-col> 
                <b-col sm="2"><b-row><b-col>{{$t("details_lamp.lamp_id")}}</b-col></b-row><b-row><b-col><strong>{{currentLamp.id}}</strong></b-col></b-row></b-col>    
            </b-row>
            <b-row class="mt-2">
                <b-col sm="3" class="ml-4"></b-col>
                <b-col sm="6">
                    <b-row>
                        <b-col>{{$t("details_lamp.lamp_desc")}}</b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="10"><strong>{{currentLamp.desc}}</strong></b-col>
                    </b-row>
                </b-col>
                <b-col sm="2">
                </b-col>     
            </b-row>        
            <hr>
            <b-row class="m-2">
                <b-col v-if="!blinking" sm="12" class="typo-label">{{$t("lamp_details_modal.how_blink")}}</b-col>
                <b-col v-if="blinking" sm="12" class="typo-label">{{$t("lamp_details_modal.blinking")}}</b-col>
            </b-row>
            <b-row>
            <b-col cols="12">
                <div>
                <b-button v-if="!blinking" class="typo-butt-command mr-1 ml-1 mt-3 but-oval" @click="sendGenericCommand('blink')"><i class="fa fa-1x fa-play mr-2"></i>{{$t("lamp_details_modal.button_blink")}}</b-button>
                <!--<b-button v-if="blinking" class="typo-butt-command mr-1 ml-1 mt-3 but-oval" @click="sendGenericCommand('stop_blink')"><i class="fa fa-1x fa-stop mr-2"></i>{{$t("lamp_details_modal.button_stop")}}</b-button>-->
                </div>
            </b-col>
            <!--<b-col cols="7">
                <div v-if="blinking"> 
                    <h1 class="mt-2">{{this.blinkActive}}</h1>
                </div>
            </b-col> --> 
            </b-row> 
        </b-modal>


    </div>
</template>

<script>

import Vue from 'vue'
import {ClientTable, Event} from 'vue-tables-2'
Vue.use(ClientTable)

import NavBarMain from '@/components/NavBarMain'
import NavBarDispositivi from '@/components/NavBarDispositivi'
import AddCentralUnit from '@/components/AddCentralUnit'
import RemoveCentralUnit from '@/components/RemoveCentralUnit'
import GroupsCentralUnit from '@/components/GroupsCentralUnit'
import AdvancedCentralUnit from '@/components/AdvancedCentralUnit'
import ParametriImpianto from '@/components/ParametriImpianto'
import ParametriUvoxy from '@/components/ParametriUvoxy'
import CreaAggregazione from '@/components/CreaAggregazione'
import CreaGruppo from '@/components/CreaGruppo'
import RimuoviGruppo from '@/components/RimuoviGruppo'
import PianificaTest from '@/components/PianificaTest'
import {showAt, hideAt} from 'vue-breakpoints'
import BannerPro from '@/components/BannerPro'
import BannerProExpired from '@/components/BannerProExpired'
import {QrcodeStream} from "vue-qrcode-reader";

//Template for print pdf
import jsPDF from 'jspdf';
import JsPDFAutotable from 'jspdf-autotable' ;


import { mapState } from 'vuex';


export default {
    name: 'DispositiviImpianto',
    components: {
        NavBarMain,
        NavBarDispositivi,
        AddCentralUnit,
        RemoveCentralUnit,
        GroupsCentralUnit,
        AdvancedCentralUnit,
        ParametriImpianto,
        ParametriUvoxy,
        CreaGruppo,
        RimuoviGruppo,
        CreaAggregazione,
        BannerPro,
        BannerProExpired,
        PianificaTest,
        ClientTable,
        Event,
        hideAt, 
        showAt, 
        QrcodeStream,
        jsPDF,
        JsPDFAutotable
    },
    props: ['plantId'],
    data() {
        return {
                cuToRemove: null,
                modalRemoveCuVisible: false,
                cuGroups:null,
                cuAdvanced:null,
                modalGroupsCuVisible:false,
                modalAdvancedCuVisible:false,
                advancedFilters: false,
                filters: {
                    search: '',
                    idCent: '',
                    nomeCent: '',
                    idLamp: '',
                    nomeLamp: '',
                    tipoCent: ['all'],
                    tipoLamp: 'all',
                    autonomia: ['all'],
                    parita: 'all',
                    infinity: 'all',
                    rete_se:'all'
                },
                selectedGroup: '',
                groups: Array.from([,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]),
                alerts: [],
                validation_alerts: [],
                currentCent: null,
                currentLamp: null,
                selected_num_lamp: null,
                selected_ore_autonomia: null,
                selected_modalita_logica: null,
                substituteLampsSelection: [],
                manual_mode_logica: "append",
                list_validation_error: null,
                hasValidationError: false,
                delete_sn: false,
                deleteAllLamps: false,
                logica_cu_list:'',
                logica_cu_array:[],
                logica_config_sn:'',
                currentLampImage: "",
                status: 'none_selected',
                righeSel: [],
                columns: ['check','image','desc','action','prodotto','dettaglio','connesso','centrale','lampade','stato'],

                tempLampDescInfos: null,
                
                configInProgress: 0,
                lamp_found: 0,
                configError: false,
                configCompleted: false,
                headerClose: true,
                
                maxchar:30,
                updatingName: false,
                editingCent:false,
                editingLamp:false,
                nomeCent: '',
                nomeLamp:'',
                cmdPianificaTest: null,
                loop: 0,

                blinking:false,
                blinkActive:0,
                blinkDuration:15,
                qrScanned: "",
                scanning: false,
                scannerInitialized: false,
                replacingCovidLamp: false,
                tableData: [],

                options: {
                    rowClassCallback: this.centRowClass,
                    filterByColumn: false,
                    uniqueKey: 'cu_id' ,
                    columnsClasses: {'desc':'descColumnClass', 'image':'imgColumnClass', 'check':'chkColumnClass','dettaglio':'dettColumnClass'},
                    headings: {
                        check:'',
                        image: '',
                        desc:'',
                        action:'',
                        prodotto:'',
                        dettaglio:'',
                        connesso:'',
                        centrale: '',
                        stato:'',
                        lampade: ''
                    }
                },
                theme: 'bootstrap4',
                template: 'default',  

                options_lamp: [
                        { value: 1, text: '1' },
                        { value: 2, text: '2' },
                        { value: 3, text: '3' },
                        { value: 4, text: '4' },
                        { value: 5, text: '5' },
                        { value: 6, text: '6' },
                        { value: 7, text: '7' },
                        { value: 8, text: '8' },
                        { value: 9, text: '9' },
                        { value: 10, text: '10' },
                        { value: 11, text: '11' },
                        { value: 12, text: '12' },
                        { value: 13, text: '13' },
                        { value: 14, text: '14' },
                        { value: 15, text: '15' },
                        { value: 16, text: '16' },
                        { value: 17, text: '17' },
                        { value: 18, text: '18' },
                        { value: 19, text: '19' },
                        { value: 20, text: '20' },
                        { value: 21, text: '21' },
                        { value: 22, text: '22' },
                        { value: 23, text: '23' },
                        { value: 24, text: '24' },
                        { value: 25, text: '25' },
                        { value: 26, text: '26' },
                        { value: 27, text: '27' },
                        { value: 28, text: '28' },
                        { value: 29, text: '29' },
                        { value: 30, text: '30' },
                        { value: 31, text: '31' },
                        { value: 32, text: '32' }
                        ],
          
                options_ore_autonomia: [
                        { value: "1H", text: '1H' },
                        { value: "1H5", text: '1H5'},
                        { value: "2H", text: '2H' },
                        { value: "3H", text: '3H' },
                        { value: "8H", text: '8H' }
                        ],

                options_modalita_logica: [
                        { value: "logica_zero", text: this.$t("config_cu_modal.logica_zero") },
                        { value: "logica_append", text: this.$t("config_cu_modal.logica_append")},
                        { value: "logica_preset", text: this.$t("config_cu_modal.logica_insert")},
                        { value: "logica_delete", text: this.$t("config_cu_modal.logica_delete")},
                        { value: "logica_substitute", text: this.$t("config_cu_modal.logica_substitute")}
                        ],
                imgData : 'data:image/jpeg;base64,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'

        }     
    
    },

    computed: {
        ...mapState(['loading','error','commandsPending', 'commandResponse']),
        centraliSel() {
            return this.righeSel.filter((v) => (v.substr(0,1) == 'c'))
        },          
        lampadeSel() {
            return this.righeSel.filter((v) => (v.substr(0,1) == 'l'))
        },
        gruppoSel() {
            console.log("Selected group", this.selectedGroup);
            return this.selectedGroup
        },
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null)  {
                this.tableData = [];
                return null;
            }
            if (plant.id != this.plantId) return null;
            return plant;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        allTableData() {
            return this.$store.state.plantUnits || [];
        }, 
        numUnits() {
            if (this.unitsDetails == null || this.unitsDetails.length == 0)  return 0;
            return this.unitsDetails.length;
        },
        totalLamps() {


            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0
            return this.unitsDetails.reduce(function(total,u){
                //return total + ((u.lamps_id == null) ? 0 : u.lamps_id.length);
                if(u.cu_type=="cablecom")
                    return total + (u.num_lamp_found | 0);
                else
                    return total + (u.num_lamp_present | 0);
            },0); 

            /*const plant = this.plantDetails;
            if (plant == null || plant.controlunits == null) return 0;

               

            return plant.controlunits.reduce(function(total,u){
                return total + u.totlamps;
            },0);*/
            
        },
        centNameInfo() {
            const nc = this.nomeCent.length;
            const validChars = /^[\x00-\x7F]*$/.test(this.nomeCent);
            if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
            if (nc > 30 || !validChars) {
                return "<b style=\"color:red\">" + nc + "/30 Caratteri</b>";
            }
            return "" + nc +"/30 Caratteri";
        },
        lampNameInfo() {
            const nl = this.nomeLamp.length;
            const validChars = /^[\x00-\x7F]*$/.test(this.nomeLamp);
            if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
            if (nl > 30 || !validChars) {
                return "<b style=\"color:red\">" + nl + "/30 Caratteri</b>";
            }
            return "" + nl +"/30 Caratteri";
        },
        uvoxyCommandEnable(){
            if (this.lampadeSel>0)
            {
                console.log("Seleizonata lampada", this.lampadeSel);
            }
        }
    },
    mounted() {
        console.log("dispositiviImpianto mounted, idImpianto=" + this.plantId + ", plantDetails:" + this.plantDetails+", allTableData:" + this.allTableData+", tableData:" + this.tableData + ", user:" + this.$store.state.user, this.allTableData, this.tableData, this.unitsDetails)
        if (this.$store.state.user != null && this.error == null && this.plantDetails == null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            this.$store.dispatch('loadPlantDetails', this.plantId)
        } else if (this.plantDetails != null && this.allTableData != null && this.tableData.length == 0) {
            
            if (this.$store.state.plantUnits == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else {
                this.tableData = this.allTableData;
                console.log("aggiornato tableData");
            }
            
            
        } 

    },
    updated() {
        console.log("dispositiviImpianto updated, idImpianto=" + this.plantId+", plantDetails=", this.plantDetails+ ", error:" + this.error)
        if (this.plantDetails == null && this.error == null && this.$store.state.user != null) {
            this.$store.dispatch('loadPlantDetails', this.plantId)
        } 
    },
    watch: {
        loading(val,oldval) {
            console.log("loading changed:" + val+", error=" + this.error+", loop=" + this.loop);
            //if (this.loop > 50) return;
            if (val == false && this.plantDetails == null && this.error == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.error == null) {
                console.log("carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
            } else if (val == false && this.$store.state.commandResponse.pending == false && this.$store.state.commandResponse.command != null && this.$store.state.commandResponse.error != "") {
               /*console.log("devo elaborare risposta fallita comando ", this.$store.state.commandResponse);
                var alert = {
                    timeLeft: 5,
                    state: "error",
                    msg: "Fallito comando " + this.$store.state.commandResponse.command.command + " su centrale " + this.$store.state.commandResponse.commandInfo.cu_id,
                    countDownChanged: function(cd) {
                        //timeLeft = cd;
                        console.log("countdownchanged:" + cd)
                    }
                }
                this.alerts.push(alert);*/
            }
        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
            console.log("Ruolo utente", this.$store.state.user.usertype);
            this.filtra();
        },
        commandResponse(val, oldval) {
            console.log("cambiata commandResponse ->", val);
            let resp = val; //this.$store.state.commandResponse
            console.log("analizzo la risposta, loop= " + this.loop  , resp);
            if (!resp.pending && resp.command != null) {
                    if (resp.error != null && resp.error != "") {
                        console.log("resp error",resp.error);
                        var alert = {
                            timeLeft: 5,
                            state: "danger",
                            msg: resp.error + ((resp.cu != "")?(" - Centrale " + (resp.cu || resp.commandInfo.cu_id)) : ""),
                            countDownChanged: function(cd) {
                                //timeLeft = cd;
                                console.log("countdownchanged:" + cd)
                            }
                        }  
                        this.alerts.push(alert);  
                    } else {
                        console.log("risposta ok per comando " + resp.command + ", cu:" + resp.cu);
                        if (resp.cu != null) {
                            var alert = {
                                timeLeft: 5,
                                state: "success",
                                msg: "Eseguito comando " + resp.command + " su centrale " + resp.cu,
                                countDownChanged: function(cd) {
                                    //timeLeft = cd;
                                    console.log("countdownchanged:" + cd)
                                }
                            }   
                            this.alerts.push(alert);
                        }
                        
                        if (this.loop > 500) {
                            console.log("Esito loop!");
                            return;
                        } else {
                            this.loop = this.loop + 1;

                            switch (resp.command) {
                                case 'SET DATE TIME PROX FUNCTIONAL TEST':
                                    if (this.cmdPianificaTest != null) {
                                        let self = this;
                                        let cuid = resp.cu;
                                        let type = resp.type; 
                                        setTimeout(function(){
                                            console.log("invio comando periodicità a centrale " + resp.cu);
                                            self.$store.dispatch('sendCablecomCommand', {cu_command: {command: 'setPeriodFunzionale', period_functional: self.cmdPianificaTest.period_functional}, cu_type: type , cu_id: cuid });
                                        },2000);
                                        
                                    }
                                    break;
                                case 'SET PERIOD FUNCTIONAL TEST':
                                    if (this.cmdPianificaTest != null && this.cmdPianificaTest.set_autonomy != "") {
                                        let self = this;
                                        let cuid = resp.cu
                                        let type = resp.type; 
                                        setTimeout(function(){
                                            console.log("invio comando test autonomia " + resp.cu);
                                            self.$store.dispatch('sendCablecomCommand', {cu_command: {command: 'setDateTimeAutonomia', set_autonomy: self.cmdPianificaTest.set_autonomy}, cu_type: type, cu_id: cuid });
                                        },2000);

                                    }
                                    break;
                                case 'SET DATE TIME PROX AUTONOMY TEST':
                                    if (this.cmdPianificaTest != null) {
                                        let self = this;
                                        let cuid = resp.cu
                                        let type = resp.type; 
                                        setTimeout(function(){
                                            console.log("invio comando periodicità autonomia a centrale " + resp.cu);
                                            self.$store.dispatch('sendCablecomCommand', {cu_command: {command: 'setPeriodAutonomia', period_autonomy: self.cmdPianificaTest.period_autonomy, differito: self.cmdPianificaTest.differito}, cu_type: type, cu_id: cuid });
                                        },2000);
                                        
                                    }
                                    break;
                                case 'savedLampDescription':
                                    console.log("elaboro saved Lamp Description",this.editingLamp);
                                    if (this.editingLamp)
                                    {
                                        this.currentLamp.desc=this.nomeLamp;
                                        this.editingLamp=false;
                                        //console.log("currentLamp:",this.currentLamp);
                                        //console.log("tableData",this.tableData);
                                        let self = this;
                                        this.tableData.forEach(function(c) {
                                            if ((c.cu_type + "#" + c.cu_id) == self.currentLamp.cu_id) {
                                                c.lamps.forEach(function(l) {
                                                    if (l.id == self.currentLamp.id) {
                                                        //console.log("ora lamp " + l.id + " -->" + l.desc);
                                                        l.desc = self.currentLamp.desc;
                                                        //console.log("aggiornata lamp " + l.id + " -->" + l.desc);
                                                        self.$nextTick(function() {
                                                            
                                                        });
                                                        
                                                    }
                                                });
                                            }
                                        });
                                    }
                                    this.updatingName = false;


                                    break;
                            }
                        }

                    }
                }




        },
        commandsPending(val,oldval) {
            console.log("commandsPending ->" + val + ", old:"+oldval+", false:" + (false+0) + ",configInProgress =" + this.configInProgress);
            if (val <= 0 && this.configInProgress > 0) {
                let cmdRes = this.$store.state.commandResponse;
                console.log("actual cmdRes:",cmdRes);
                if (cmdRes.cu == this.currentCent.cu_id) {
                    if (cmdRes.command == "GET DATI IMPIANTO") {
                        this.lamp_found = cmdRes.response.lamp_found;

                        //non mostro le lampade in tabella mentre è in corso l'acqusiizione
                        this.tableData = this.allTableData.filter(cent => {
                           if(cent.cu_id != this.currentCent.cu_id)
                                {
                                    return cent;
                                }
                                else
                                {
                                    if(cent.cu_type == this.currentCent.cu_type)
                                    {
                                        cent.lamps=[];
                                        cent.working=true;
                                        cent.num_lamp_found=-1;
                                        return cent;
                                    }
                                    else
                                    {
                                        return cent;
                                    }
                                }
                            });
                        
                        

                        console.log("stato della configurazione ",cmdRes.response.status_config.searching, this.lamp_found);
                        if (cmdRes.response.status_config.searching == "1") {
                            console.log("sta ancora cercando");
                            this.configInProgress = setTimeout(this.checkConfigStatus,2000);
                        } else {
                            console.log("ha finito di cercare, trovate: " + this.lamp_found + ", cercate: " + this.selected_num_lamp);
                            if (this.lamp_found != this.selected_num_lamp && cmdRes.type == "cablecom") {
                                this.configError = true;
                                this.configInProgress = 0;
                                this.headerClose = true;
                            } else {
                                const self = this;
                                this.configCompleted = true;
                                this.configError = false;
                                this.configInProgress = 0;
                                setTimeout(function() {
                                    self.currentCent = null;
                                    self.configCompleted = false;
                                    self.configInProgress = false;
                                    self.$bvModal.hide('config-cent-modal');
                                    self.headerClose = true;
                                },3000);
                            }
                        }
                    }
                }
            } else if (val <=0 && this.updatingName) {
                let resp = this.$store.state.commandResponses[""+this.currentCent.cu_id];
                console.log("completato editing name", resp);
                if (resp != null) {
                    if (resp.error != null && resp.error != "") {
                        this.updatingName = false
                        this.$bvModal.msgBoxOk(resp.error);
                    } else 
                    {
                        if (this.editingCent)
                        {
                            this.currentCent.cu_desc = this.nomeCent;
                            this.editingCent=false;
                            let self = this;
                            this.tableData.forEach(function(c) {
                                if (c.cu_id == self.currentCent.cu_id && c.cu_type == self.currentCent.cu_type) {
                                    c.cu_desc = self.currentCent.cu_desc;
                                    self.$nextTick(function() {
                                                
                                    });
                                }
                            });
                        }
                        else if (this.editingLamp)
                        {
                            this.currentLamp.desc=this.nomeLamp;
                            this.editingLamp=false;
                            //console.log("currentLamp:",this.currentLamp);
                            //console.log("tableData",this.tableData);
                            let self = this;
                            this.tableData.forEach(function(c) {
                                if ((c.cu_type + "#" + c.cu_id) == self.currentLamp.cu_id) {
                                    c.lamps.forEach(function(l) {
                                        if (l.id == self.currentLamp.id) {
                                            //console.log("ora lamp " + l.id + " -->" + l.desc);
                                            l.desc = self.currentLamp.desc;
                                            //console.log("aggiornata lamp " + l.id + " -->" + l.desc);
                                            self.$nextTick(function() {
                                                
                                            });
                                            
                                        }
                                    });
                                }
                            });
                        }
                        this.updatingName = false;
                    }
                }
            }
            
        }
    },
    methods: {
        numUnitsOk() {
            var CuOk=[];
            if (this.unitsDetails == null || this.unitsDetails.length == 0)  return 0;
    
            for (let k=0;k<this.unitsDetails.length;k++)
            {
               if(this.unitsDetails[k].cu_error)
               {
                if((this.unitsDetails[k].num_lamp_error=="0") 
                && (this.unitsDetails[k].cu_error.error_batt_low_voltage=="OFF")
                && (this.unitsDetails[k].cu_error.error_batt_not_connected=="OFF")
                && (this.unitsDetails[k].cu_error.error_duplicated_id_lamp=="OFF")
                && (this.unitsDetails[k].cu_error.error_lg=="OFF")
                && (this.unitsDetails[k].cu_error.error_missing_lamp_in_config=="OFF")
                && (this.unitsDetails[k].cu_error.error_more_32_lamp_in_config=="OFF")
                && (this.unitsDetails[k].cu_error.error_overload=="OFF")
                && (this.unitsDetails[k].cu_error.error_too_much_lamp_in_config=="OFF")
                && (this.unitsDetails[k].cu_error.error_wiring=="OFF")
                && (this.unitsDetails[k].cu_connected==true))
                {
                CuOk.push(this.unitsDetails[k].cu_id);
                }
               }
            }
            console.log("CU funzionanti",CuOk);
            return CuOk.length;
     },
        numUnitsDisconnected() {
            var CuDisconnected=[];
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
               {
                if(this.unitsDetails[k].cu_connected==false)
                  CuDisconnected.push(this.unitsDetails[k].cu_id);
               }
               console.log("CU non raggiungibili",CuDisconnected);
               return CuDisconnected.length;
        },
        numUnitsFail() {
            var CuFail=[];
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
            {
               if(this.unitsDetails[k].cu_error)
               {
                if(((this.unitsDetails[k].num_lamp_error!="0") 
                || (this.unitsDetails[k].cu_error.error_batt_low_voltage=="ON")
                || (this.unitsDetails[k].cu_error.error_batt_not_connected=="ON")
                || (this.unitsDetails[k].cu_error.error_duplicated_id_lamp=="ON")
                || (this.unitsDetails[k].cu_error.error_lg=="ON")
                || (this.unitsDetails[k].cu_error.error_missing_lamp_in_config=="ON")
                || (this.unitsDetails[k].cu_error.error_more_32_lamp_in_config=="ON")
                || (this.unitsDetails[k].cu_error.error_overload=="ON")
                || (this.unitsDetails[k].cu_error.error_too_much_lamp_in_config=="ON")
                || (this.unitsDetails[k].cu_error.error_wiring=="ON"))
                && (this.unitsDetails[k].cu_connected==true))
                {
                    CuFail.push(this.unitsDetails[k].cu_id);
                }
               }
            }
            console.log("CU in errore",CuFail);
            return CuFail.length;

        },
        numLampsDisconnected() {
            var numLampDisconnected=0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
            {
               if(this.unitsDetails[k].cu_connected==false)
               numLampDisconnected=numLampDisconnected+this.unitsDetails[k].lamps.length;
            }
            console.log("CU LAMP non raggiungibili: " ,numLampDisconnected);
            return numLampDisconnected;
        },
        numLampsFail() {
            var numLampFail=0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
            {
               if(this.unitsDetails[k].cu_connected==true)
               numLampFail=numLampFail + this.unitsDetails[k].num_lamp_error;
            }
            console.log("CU LAMP in errore: " ,numLampFail);
            return numLampFail;
        },
        numLampsOk() {
            var numLampOk=0;
            /*if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
            {
               if(this.unitsDetails[k].cu_connected==true)
               numLampOk=this.totalLamps-this.numLampsFail-this.numLampsDisconnected;
            }
            console.log("CU LAMP funzionanati: " ,numLampOk);*/
            return this.totalLamps - this.numLampsFail() - this.numLampsDisconnected();

            return numLampOk;
        },
        
        //create Pdf Impianto
        createPDF_Impianto() {
            let self = this;
            
            //console.log("total lamps:" + self.totalLamps);
            //return

            //Define header and table name
            
            let plant_header=this.plantDetails.plantname;
            var date_now = new Date();
            let table_name=plant_header;

            // Only pt supported (not mm or in)
            var doc = new jsPDF('p', 'pt');
           
            doc.addImage(this.imgData, 'PNG', 38, 15, 70, 20);
            doc.setFont("helvetica");
            
            //Creation date info
            doc.setFontSize(8);
            doc.setFontType("normal");
            doc.text(this.$t('report_pdf.title_create_date') + " : " + date_now.toLocaleDateString() + date_now.toLocaleTimeString(),400,70); 
    
            //Plant header
            doc.setFontType("bold");
            doc.setFontSize(12);
            doc.text(this.plantDetails.plantname,38,95);        

            //Info number cu and num lamps
            doc.setFontType("normal");
            doc.setFontSize(10);
            doc.text(this.plantDetails.address.street + " " + this.plantDetails.address.housenumber,38,110);       
            doc.text(this.plantDetails.address.cap + " - " + this.plantDetails.address.city + " (" + this.plantDetails.address.prov +") " + this.plantDetails.address.country,38,125);       

            doc.setFontType("bold");
            doc.text(this.$t('report_pdf.num_centrali') + " : " + self.numUnits ,38,160);
            doc.setFontType("normal");
            doc.text(this.$t('report_pdf.num_centrali_ok') + " : " + self.numUnitsOk() ,38,180); 
            doc.text(this.$t('report_pdf.num_centrali_fail') + " : " + self.numUnitsFail() ,38,200);
            doc.text(this.$t('report_pdf.num_centrali_disconnected') + " : " + self.numUnitsDisconnected() ,38,220); 

            doc.setFontType("bold");
            doc.text(this.$t('report_pdf.num_lampade') + " : " + self.totalLamps ,38,260);
            doc.setFontType("normal");
            doc.text(this.$t('report_pdf.num_lampade_ok') + " : " + self.numLampsOk() ,38,280); 
            doc.text(this.$t('report_pdf.num_lampade_fail') + " : " + self.numLampsFail() ,38,300);
            doc.text(this.$t('report_pdf.num_lampade_disconnected') + " : " + self.numLampsDisconnected() ,38,320); 
          
            var centData = [];
            if (self.centraliSel.length > 0) {
                for (var i=0; i<self.centraliSel.length; i++) {
                    var centId = self.centraliSel[i].substr(5);
                    var cent = self.tableData[centId];
                    console.log("centId",centId, cent);
                    centData.push(cent);
                }
            } else {
                centData = centData.concat(self.unitsDetails);
            }
            console.log("centData:",centData);

            var columns = [
                {title: "ID", dataKey: "id"},
                {title: "Desc.", dataKey: "desc"}, 
                {title: "Order code", dataKey: "code"}, 
                {title: "Tipo", dataKey: "type"},
                {title: "Autonomia", dataKey: "autonomia"},
                {title: "Parità", dataKey: "parita"},
                {title: "Stato", dataKey: "status"}
            ];

        
            for (var p = 0; p < centData.length; p++) {
                doc.addPage();
                var cent = centData[p];
                //Info number cu and num lamps
                doc.setFontType("bold");
                doc.setFontSize(12);
                doc.text(this.$t('report_pdf.title_centrale') + " : " + cent.cu_type + " " + cent.cu_id,38,50);
                doc.setFontType("normal");
                doc.setFontSize(10);
                doc.text(this.$t('report_pdf.centrale_desc') + " : " + cent.cu_desc,38,65);
                doc.setFontSize(8);
                doc.text(this.$t('details_cu_modal.cu_numero_lampade') + " : " + cent.num_lamp_found,38,90);
                doc.text(this.$t('details_cu_modal.cu_numero_lampade_errore') + " : " + cent.num_lamp_error,38,102);
                doc.text(this.$t('details_cu_modal.cu_prossimo_test_funzionale') + " : " + self.moment(cent.cu_next_funct_test,).format('DD MMM YYYY - HH:mm'),38,120);
                doc.text(this.$t('details_cu_modal.cu_prossimo_test_autonomia') + " : " + self.moment(cent.cu_next_auto_test,).format('DD MMM YYYY - HH:mm'),38,132);
                doc.text(this.$t('details_cu_modal.cu_periodicita_test_funzionale') + " : " + cent.cu_period_funct_test + " gg",38,144);
                doc.text(this.$t('details_cu_modal.cu_periodicita_test_autonomia') + " : " + cent.cu_period_auto_test + " gg",38,156);
                doc.text(this.$t('details_cu_modal.test_differito') + " : " + cent.cu_status.test_differito + " gg",38,168);
                doc.text(this.$t('details_cu_modal.prima_installazione') + " : " + self.moment(String(new Date(cent.first_installation_timestamp))).format('DD MMM YYYY - HH:mm'),38,180);
                
                var rows = [];
                var tablePage = 0;
                var maxPageLamps = 30
                var tLamps = cent.lamps.length;
                var currLampsCount = 0;

                while (currLampsCount < tLamps) {
                    var rows = [];
                    for (var r=currLampsCount; r< Math.min(tLamps, currLampsCount + maxPageLamps); r++) {
                        var l = cent.lamps[r];
                        rows.push({
                            id: l.id ,
                            desc: l.desc,
                            code: l.order_code,
                            type: l.lamp_type,
                            autonomia: l.autonomy,
                            parita: l.parity,
                            status: (l.emer_active=='EMERGENZA IN CORSO') ? "emergency" : (l.error_batt_short=="OFF" && l.error_batt_test=="OFF" && l.error_com=="OFF" && l.error_hardware=="OFF" && l.error_led=="OFF") ? "ok" : "error"
                        })
                    }
                    if (tablePage > 0) {
                        doc.addPage();
                        doc.setFontType("bold");
                        doc.setFontSize(12);
                        doc.text(this.$t('report_pdf.title_centrale') + " : " + cent.cu_type + " " + cent.cu_id + ", Lampade: " + (currLampsCount+1) + " - " + Math.min(tLamps, currLampsCount + maxPageLamps) ,38,50);
                    }

                    doc.autoTable({
                        columns,
                        body: rows,                      
                        startY: (tablePage>0) ? 80 : 190,
                        theme: 'striped',
                        styles: {
                                fontSize: 7,
                                font: "helvetica", // helvetica, times, courier
                                fontStyle: 'normal', // normal, bold, italic, bolditalic
                                halign: 'left', // left, center, right
                        },
                        headStyles: {},
                        bodyStyles: {},
                        alternateRowStyles: {},
                        columnStyles: {}
                    });

                    doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width/2 - 35), doc.internal.pageSize.height - 40, 70, 20);

                    tablePage += 1;
                    currLampsCount += maxPageLamps;
                    maxPageLamps = 35;
                }


                /*for (var r=0; r< cent.lamps.length; r++) {
                    var l = cent.lamps[r];

                    rows.push({
                        id: l.id ,
                        desc: l.desc,
                        code: l.order_code,
                        type: l.lamp_type,
                        autonomia: l.autonomy,
                        parita: l.parity,
                        status: (l.emer_active=='EMERGENZA IN CORSO') ? "emergency" : (l.error_batt_short=="OFF" && l.error_batt_test=="OFF" && l.error_com=="OFF" && l.error_hardware=="OFF" && l.error_led=="OFF") ? "ok" : "error"
                    })

                    doc.autoTable({
                        columns,
                        body: rows,                      
                        startY: 190,
                        theme: 'striped',
                        styles: {
                                fontSize: 7,
                                font: "helvetica", // helvetica, times, courier
                                fontStyle: 'normal', // normal, bold, italic, bolditalic
                                halign: 'left', // left, center, right
                        },
                        headStyles: {},
                        bodyStyles: {},
                        alternateRowStyles: {},
                        columnStyles: {}
                    });
                    


                doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width/2 - 35), doc.internal.pageSize.height - 40, 70, 20);
            }*/
            }


            doc.save(table_name);


        },
        validateSubstituteList(value) {
            if (this.substituteLampsSelection == null || this.substituteLampsSelection.length == 0) {
                alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg:this.$t("config_cu_modal.logica_sn_empty_selection"),
                    countDownChanged: function(cd) {
                        console.log("countdownchanged:" + cd)
                    }
                }  
                this.validation_alerts.push(alert); 
                console.log("errore 1");
                return false;
            }
            var array_serial=value.split(/[\r\n,]+/gm);
            if(array_serial.toString()=="" || array_serial.length==0) {
                     alert = {
                            timeLeft: 5,
                            state: "danger",
                            msg:this.$t("config_cu_modal.logica_sn_empty_error"),
                            countDownChanged: function(cd) {
                                console.log("countdownchanged:" + cd)
                            }
                        }  
                        this.validation_alerts.push(alert);  
                        return false
            }
            var lampArr = [];
            for(var i=0; i< array_serial.length; i++) {
                array_serial[i]=array_serial[i].trim().replaceAll(/[\r\n]+/gm, "");
                if (array_serial[i] == "") continue;
                var reg=array_serial[i].match(/^[a-f0-9,]{4}$/i);
                if (reg == null) {
                    alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg:this.$t("config_cu_modal.logica_sn_format_error"),
                        countDownChanged: function(cd) {
                            console.log("countdownchanged:" + cd)
                        }
                    }  
                    this.validation_alerts.push(alert);  
                    return false
                }
                lampArr.push(array_serial[i].toUpperCase());
            }
            
            if (lampArr.length != this.substituteLampsSelection.length) {
                alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg:this.$t("config_cu_modal.logica_sn_invalid_id_selection"),
                    countDownChanged: function(cd) {
                        console.log("countdownchanged:" + cd)
                    }
                }  
                this.validation_alerts.push(alert);  
                return false
            }

            //non devono esserci id doppi e nemmeno id già presenti
            for (var i=0; i< lampArr.length; i++) {
                if (this.currentCent.lamps_id.indexOf(lampArr[i]) >= 0) {
                    alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg:this.$t("config_cu_modal.logica_sn_id_already_present")+ lampArr[i],
                        countDownChanged: function(cd) {
                            console.log("countdownchanged:" + cd)
                        }
                    }  
                    this.validation_alerts.push(alert);  
                    return false
                }
                if (lampArr.indexOf(lampArr[i]) != i) {
                    alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg:this.$t("config_cu_modal.logica_sn_duplicated_error"),
                        countDownChanged: function(cd) {
                            console.log("countdownchanged:" + cd)
                        }
                    }  
                    this.validation_alerts.push(alert);  
                    return false
                }
            }


            console.log("check ok!");
            this.logica_array_sn = lampArr;

            return true;

        },

        validateSerialList(value){
                console.log("verifico lampade inserite");
               this.logica_array_sn=[];
               this.list_validation_error = null;
  
               //split on , or carriagereturn
               var array_serial=value.split(/[\r\n,]+/gm);
  
               //reg expression hexadecimal 4 char oppure n:XXXX per poter forzare una posizione
               var trovatoForzaPos = false;
               var overWriteMode = (this.manual_mode_logica == 'overwrite');
               if(array_serial.toString()=="" || array_serial.length==0)
               {
                     alert = {
                            timeLeft: 5,
                            state: "danger",
                            msg:this.$t("config_cu_modal.logica_sn_empty_error"),
                            countDownChanged: function(cd) {
                                console.log("countdownchanged:" + cd)
                            }
                        }  
                        this.validation_alerts.push(alert);  
                        return false
               }

               for(var j=0;j<array_serial.length;j++)
               {
                    array_serial[j]=array_serial[j].trim().replaceAll(/[\r\n]+/gm, "")
                    var reg=array_serial[j].match(/^([0-9]{1,3}:)?[a-f0-9,]{4}$/i);
                    if(reg==null) {
                          alert = {
                            timeLeft: 5,
                            state: "danger",
                            msg:this.$t("config_cu_modal.logica_sn_format_error"),
                            countDownChanged: function(cd) {
                                console.log("countdownchanged:" + cd)
                            }
                        }  
                        this.validation_alerts.push(alert);  
                        return false
                    } 
                    var dato = array_serial[j];
                    if (dato.indexOf(":") > 0) {
                        /*if (!overWriteMode) {
                                alert = {
                                timeLeft: 5,
                                state: "danger",
                                msg:this.$t("config_cu_modal.logica_sn_append_error"),
                                countDownChanged: function(cd) {
                                console.log("countdownchanged:" + cd)
                            }
                        }  
                        this.validation_alerts.push(alert);  
                        return false
                        } */
                  
                        var pos = parseInt(dato.substr(0,dato.indexOf(":")),10);
                        if (pos < 1 || pos > 128) {
                                alert = {
                                timeLeft: 5,
                                state: "danger",
                                msg:this.$t("config_cu_modal.logica_sn_position_error"),
                                countDownChanged: function(cd) {
                                console.log("countdownchanged:" + cd)
                            }
                        }  
                        this.validation_alerts.push(alert);  
                        return false
                        }
                    }
               }
               console.log("step1");

               //Controllo id duplicati compatibile con la presenza di posizioni forzate 
               var dopArray = [];
               var posArray = [];
               for(var i=0;i<array_serial.length;i++)
               {
                   var ser = array_serial[i]
                   var dp = ser.indexOf(":");
                   if (dp>0) {
                    var pos = ser.substr(0,dp);
                    if (posArray[pos] != null) {
                        alert = {
                                timeLeft: 5,
                                state: "danger",
                                msg:this.$t("config_cu_modal.logica_pos_duplicated_error"),
                                countDownChanged: function(cd) {
                                console.log("countdownchanged:" + cd)
                            }
                        }  
                        this.validation_alerts.push(alert);  
                        return false
                    }
                    posArray[pos] = pos;
                    ser = ser.substr(dp+1);
                   }
                   if (dopArray[ser] != null) {
                        alert = {
                                timeLeft: 5,
                                state: "danger",
                                msg:this.$t("config_cu_modal.logica_sn_duplicated_error"),
                                countDownChanged: function(cd) {
                                console.log("countdownchanged:" + cd)
                            }
                        }  
                        this.validation_alerts.push(alert);  
                        return false
                   } 

                   //Se sono in append non posso avere lampade duplicate rispetto quelle già presenti
                   if (!overWriteMode && this.logica_cu_list.indexOf(ser) >= 0) {
                        alert = {
                                timeLeft: 5,
                                state: "danger",
                                msg:this.$t("config_cu_modal.logica_sn_existing_error"),
                                countDownChanged: function(cd) {
                                console.log("countdownchanged:" + cd)
                            }
                        }  
                        this.validation_alerts.push(alert);  
                        return false
                   }

                   dopArray[ser] = ser;
               }
               console.log("step2");

               console.log("check finito ok!");
               
               
               this.logica_array_sn=array_serial;
               return true
        },
        lampadeSelObject(){
            let lamp;
            for (var csel in this.lampadeSel) {
                    let c = this.lampadeSel[csel].split("-")
                    lamp = this.tableData[parseInt(c[1])]
                }
            console.log("Triggered lamp",lamp);    
            return lamp;    
        },
        centSelObject(cu){
            if (this.centraliSel.length >0)
            {
                let cent;
                for (var csel in this.centraliSel) {
                        let c = this.centraliSel[csel].split("-")
                        cent = this.tableData[parseInt(c[1])]
                    }
                if(cu.cu_id == cent.cu_id && cu.cu_type == cent.cu_type)
                {
                    return true
                }
            }    
            return false;    
        },
        centRowClass(cent) {
            //console.log("centRowClass ", dataItem, index);
            if (!cent.enabled) return "cent-disabled";
            return "";
        },
        autonomiaChanged(newVal) {
            console.log("autonomiaChanged",newVal, this.filters.autonomia);
            let self = this;
            Vue.nextTick(function () {
                if (self.filters.autonomia.length == 0) {
                    self.filters.autonomia = ['all'];
                } else if (self.filters.autonomia.length > 1 && self.filters.autonomia[0] == 'all') {
                    self.filters.autonomia.shift();
                } else if (self.filters.autonomia.length > 1 && self.filters.autonomia[self.filters.autonomia.length-1] == 'all') {
                    self.filters.autonomia = ['all'];
                }
                console.log("autonomia->",self.filters.autonomia);
            })

            
        },
        tipoCentChanged(newVal) {
            console.log("tipoCentChanged",newVal, this.filters.tipoCent);
            let self = this;
            Vue.nextTick(function () {
                if (self.filters.tipoCent.length == 0) {
                    self.filters.tipoCent = ['all'];
                } else if (self.filters.tipoCent.length > 1 && self.filters.tipoCent[0] == 'all') {
                    self.filters.tipoCent.shift();
                } else if (self.filters.tipoCent.length > 1 && self.filters.tipoCent[self.filters.tipoCent.length-1] == 'all') {
                    self.filters.tipoCent = ['all'];
                }
                console.log("tipoCent->",self.filters.tipoCent);
            })

            
        },
        filtra() {
            let self = this;
            if (!this.advancedFilters) {
                //filtro semplice
                let fltArr = this.filters.search.trim().toLowerCase().split(",",-1);
                console.log("filtro semplice:", fltArr);
                
                if (this.filters.search.trim() == '') {
                    this.allTableData.forEach(cent => {
                        
                        if (cent.lamps != null && cent.lamps.length > 0) {
                            cent.lamps.forEach(lamp => {
                                lamp['visible'] = true;
                            });
                        }
                    });
                    this.tableData = this.allTableData;
                } else {
                    this.tableData = this.allTableData.filter(cent => {
                        console.log("cent:",cent);
                        
                        var match = false;
                        for (var f = 0; f < fltArr.length; f++) {
                            let flt = fltArr[f].trim();
                            var found = (cent.cu_id == flt) || (cent.cu_desc || '').toLowerCase().includes(flt);
                            if (found) {
                                match = true;
                                if (cent.lamps != null && cent.lamps.length > 0) {
                                    cent.lamps.forEach(lamp => {
                                        lamp['visible'] = true;
                                    });
                                } 
                                break;
                            }
                            if (cent.lamps != null && cent.lamps.length > 0) {
                                    cent.lamps.forEach(lamp => {
                                        if (lamp.id.toLowerCase() == flt || (lamp.desc || '').toLowerCase().includes(flt)) {
                                            lamp['visible'] = true;
                                            found = true;
                                        } else {
                                            lamp['visible'] = false;
                                        }
                                    });
                            }
                            if (found) {
                                match = true;
                                break;
                            } 
                        }
                        return match;
                    });
                    console.log("tableData:",this.tableData);
                }


            } else {
                console.log("filtri avanzati:",this.filters);
                this.tableData = this.allTableData.filter(cent => {
                    console.log("cent:",cent);
                    var centOk = true;
                    //filtri su centrale
                    if (self.filters.idCent.trim() != '') {
                        let fltArr = self.filters.idCent.trim().toLowerCase().split(',',-1);
                        var match = false;
                        for (var f = 0; f < fltArr.length; f++) {
                            let flt = fltArr[f].trim();
                            var found = (cent.cu_id == flt); // || (cent.cu_desc || '').toLowerCase().includes(flt);
                            if (found) {
                                match = true;
                                break;
                            }
                        }
                        if (! match) centOk = false;
                    } 
                    if (centOk && self.filters.nomeCent.trim() != '') {
                        let fltArr = self.filters.nomeCent.trim().toLowerCase().split(',',-1);
                        var match = false;
                        for (var f = 0; f < fltArr.length; f++) {
                            let flt = fltArr[f].trim();
                            var found = (cent.cu_desc || '').toLowerCase().includes(flt);
                            if (found) {
                                match = true;
                                break;
                            }
                        }
                        if (! match) centOk = false;
                    } 
                    if (centOk && self.filters.tipoCent.length>0 && self.filters.tipoCent[0] != 'all') {
                        var found = false;
                        self.filters.tipoCent.forEach(tipoCent => {
                            if (cent.cu_type == tipoCent) found = true;
                        });
                        if (!found) centOk = false;
                    }
                    //filtri su lampade
                    if (centOk && cent.lamps != null && cent.lamps.length > 0) {
                        var oneLampVisible = false;
                        cent.lamps.forEach(lamp => {
                            var visible = true;
                            
                            if (self.filters.idLamp.trim() != '') {
                                let fltArr = self.filters.idLamp.trim().toLowerCase().split(',',-1);
                                var match = false;
                                for (var f = 0; f < fltArr.length; f++) {
                                    let flt = fltArr[f].trim();
                                    var found = (lamp.id.toLowerCase() == flt); // || (cent.cu_desc || '').toLowerCase().includes(flt);
                                    if (found) {
                                        match = true;
                                        break;
                                    }
                                }
                                if (! match) visible = false;
                            } 
                            if (visible && self.filters.nomeLamp.trim() != '') {
                                let fltArr = self.filters.nomeLamp.trim().toLowerCase().split(',',-1);
                                var match = false;
                                for (var f = 0; f < fltArr.length; f++) {
                                    let flt = fltArr[f].trim();
                                    var found = (lamp.desc || '').toLowerCase().includes(flt);
                                    if (found) {
                                        match = true;
                                        break;
                                    }
                                }
                                if (! match) visible = false;
                            } 
                            if (visible && self.filters.tipoLamp != 'all') {
                                if (self.filters.tipoLamp == 'oxy' && lamp.sanificaaria != true) {
                                    visible = false;
                                } else if (self.filters.tipoLamp != 'oxy' && lamp.sanificaaria == true) {
                                    visible = false;
                                } else if (self.filters.tipoLamp == 'SA' && lamp.lamp_type != 'SA') {
                                    visible = false;
                                } else if (self.filters.tipoLamp == 'SE' && lamp.lamp_type != 'SE') {
                                    visible = false;
                                }
                            }
                            if (visible && self.filters.rete_se != 'all') {
                                if (self.filters.rete_se == 'SE_ON' && lamp.emer_active != 'NO') {
                                    visible = false;
                                } else if (self.filters.rete_se == 'SE_OFF' && lamp.emer_active == 'NO') {
                                    visible = false;
                                }
                            }
                            if (visible && self.filters.autonomia.length >0 && self.filters.autonomia[0] != 'all') {
                                var found = false;
                                self.filters.autonomia.forEach(aut => {
                                    if (lamp.autonomy == aut) found = true;
                                });
                                if (!found) visible = false;
                            }
                            if (visible && self.filters.parita != 'all') {
                                if (lamp.parity != self.filters.parita) visible = false;
                            }
                            if (visible && self.filters.infinity != 'all') {
                                if (lamp.lssa != self.filters.infinity) visible = false;
                            }
                            if (visible) oneLampVisible = true;
                            lamp['visible'] = visible;
                        });
                        if (!oneLampVisible) centOk = false;
                    }
                    if (centOk && (cent.lamps == null || cent.lamps.length == 0)) {
                        if (self.filters.idLamp.trim() != '' || self.filters.nomeLamp.trim() != '' || self.filters.tipoLamp != 'all' || self.filters.parita != 'all' || self.filters.infinity != 'all' || self.filters.rete_se != 'all' || (self.filters.autonomia.length > 0 && self.filters.autonomia[0] != 'all')) {
                            centOk = false;
                        } 
                    }

                    return centOk;
                });
                console.log("tableData:",this.tableData);
            }

            if (this.selectedGroup != "") {
                let self = this;
                let sg = parseInt(this.selectedGroup);
                console.log("devo filtrare anche per gruppo " + this.selectedGroup);
                this.tableData = this.tableData.filter(cent => {
                        //console.log("cent:",cent);
                        if (cent.cu_type == 'cablecom' || cent.lamps == null || cent.lamps.length == 0) return false;
                        var lampGroups = cent.lamps.filter((lamp) =>{
                            if (lamp.groups == null || lamp.groups.length == 0) return false;
                            return lampGroups=lamp.groups.includes(sg);
                        })
                        console.log("filtr centrale " + cent.cu_id+" lamp groups:",lampGroups);
                        for(var i=0;i<this.tableData.length;i++)
                        {
                           if(this.tableData[i].cu_id==cent.cu_id)
                           {
                              for(var k=0;k<this.tableData[i].lamps.length;k++)
                              {
                                  this.tableData[i].lamps[k]['visible']=false
                              }
                           }
                        }

                        for(var i=0;i<lampGroups.length;i++)
                        {
                            lampGroups[i]['visible']=true;
                        }
                        
                        return (lampGroups != null && lampGroups.length > 0);
                });
            }

        },
        clearFilters() {
            this.filters = {
                    search: '',
                    idCent: '',
                    nomeCent: '',
                    idLamp: '',
                    nomeLamp: '',
                    tipoCent: ['all'],
                    tipoLamp: 'all',
                    autonomia: ['all'],
                    rete_se:'all',
                    parita: 'all',
                    infinity: 'all'
                };
            this.filtra();
        },
        showFilters() {
            console.log("mostro filtri avanzati");
            this.advancedFilters = true;
            this.clearFilters();
            
        },
        hideFilters() {
            console.log("nascondo filtri avanzati");
            this.advancedFilters = false;
            this.clearFilters();
        },
        onDecode(decodedString) {
            console.log("codeScanned:",decodedString);
            this.qrScanned = decodedString;
          //setTimeout(function() {
            this.scanning = false;
          //},2000);
          
        },
        async onInit(promise) {
            try {
                await promise;
                this.scannerInitialized = true;
            } catch (error) {
                console.log("error on init", error);
                this.qrScanned = "" + error;
            }
        },
        async startScan() {
            if (this.scannerInitialized) {
                this.scannerInitialized = false;
                await this.$nextTick();
                
            }
            this.qrScanned = ''
            this.scanning = true;
        },
        replaceCovidLamp() {
            let self = this;
            this.$bvModal.msgBoxConfirm("Confermi l'avvenuta sostituzione della lampada Covid con il ricambio n° " + self.qrScanned +  " ?", {
                title: 'Conferma sostituzione lampada',
                okVariant: 'success',
                okTitle: 'Sostituisci',
                cancelTitle: 'CHIUDI',
                centered: true
            }).then((value) => {
                if (value == true) {
                    self.replacingCovidLamp = true;
                    setTimeout(function() {
                        self.replacingCovidLamp = false;
                        self.qrScanned = "";
                    }, 5000);
                    //self.$store.dispatch('updateUserValidation', {callerId: callerId, userId: user.id, validationStatus: 'validated'});
                }
            });
        },
        descrStato(value) {
            return (value.cu_connected) ? this.$t("connessa") : this.$t("disconnessa")
        },
        tipoCentrale(value) {
            if (value == 'cablecom') return this.$("central_unit") + " CableCom"
            return this.$("central_unit") + " " + value
        },
        ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0) return user[0].role;
            return "?";
        },
        passaAPro() {
             this.$router.push({
                name: "GeneraliImpianto",
                params: { plantId: this.$store.state.currentPlant.id }
            });
        },
        toggleLamps(cu_id) {
            this.$root.$emit('bv::toggle::collapse', 'collapse-'+cu_id)
        },
        editNomeLamp() {
            this.nomeLamp = this.currentLamp.desc;
            this.editingLamp = true;
        },
        abortNomeLamp() {
            this.editingLamp = false;
        },
        saveNomeLamp() {
        console.log("Provo a salvare il nome della lampada",this.currentCent);
        const validChars = /^[\x00-\x7F]*$/.test(this.nomeLamp);
            if (!validChars) {
                console.log("Invalid chars");
                this.$bvModal.msgBoxOk("La descrizione della lampada non può contenere caratteri speciali e lettere accentate");
                return;
            }

            if (this.nomeLamp.length > 30) {
                console.log("Troppo lunga");
                this.$bvModal.msgBoxOk("La descrizione della centrale non può superare i 30 caratteri");
                return;
            }
            this.tempLampDescInfos = {cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id,lamp_id:this.currentLamp.id,lamp_desc: this.nomeLamp};
            //this.$store.dispatch('sendCablecomCommand', {cu_command: 'setLampName',cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, lampName: this.nomeLamp, lampIndex:this.currentLamp.index, lampId: this.currentLamp.id});
            this.$store.dispatch("dbSaveLampDescription", this.tempLampDescInfos);

            //this.currentCent.cu_desc = this.nomeCent;
            //this.editingName = false;
            this.updatingName = true;
            let self = this;
            /*setTimeout(function(){
                self.currentCent.cu_desc = self.nomeCent;
                self.editingName = false;
                self.updatingName = false;
            },3000);*/
        },
        editNomeCent() {
            this.nomeCent = this.currentCent.cu_desc;
            this.editingCent = true;
        },
        abortNomeCent() {
            this.editingCent = false;
        },
        saveNomeCent() {

            const validChars = /^[\x00-\x7F]*$/.test(this.nomeCent);
            if (!validChars) {
                this.$bvModal.msgBoxOk("La descrizione della centrale non può contenere caratteri speciali e lettere accentate");
                return;
            }

            if (this.nomeCent.length > 30) {
                this.$bvModal.msgBoxOk("La descrizione della centrale non può superare i 30 caratteri");
                return;
            }
      
            this.$store.dispatch('sendCablecomCommand', {cu_command: 'setCuName',cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, cuName: this.nomeCent});
            //this.currentCent.cu_desc = this.nomeCent;
            //this.editingName = false;
            this.updatingName = true;
            let self = this;
            /*setTimeout(function(){
                self.currentCent.cu_desc = self.nomeCent;
                self.editingName = false;
                self.updatingName = false;
            },3000);*/
        },
        mostraPaginaCentrali() {
            this.$router.push({name: 'Centrali', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaTuttiDispositivi() {
            this.$router.push({name: 'TuttiDispositivi', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaPlanimetrie() {
            this.$router.push({name: 'Planimetrie', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaAmbienti() {
            this.$router.push({name: 'Ambienti', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaPlanimetrie() {
            this.$router.push({name: 'Planimetrie', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaZone() {
            this.$router.push({name: 'Zone', params: {pid: this.$store.state.currentPlant.id}})
        },
        sendGenericCommand(cu_command) {
            let self = this
            if(cu_command=="blink") {
                    this.blinking=true;
                    //---rimosso timer blinking
                    //this.blinkActive=this.blinkDuration;
                    //let self=this;
                    //self.blinkingTimer();
                    this.$store.dispatch('sendCablecomCommand', {cu_command,cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, addr: this.currentLamp.id});
            }
            else if(cu_command=="stop_blink_single") {
                    this.blinking=false;
                    cu_command="stop_blink";
                    this.$store.dispatch('sendCablecomCommand', {cu_command,cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, addr: "FFFF"});
            }
            else if (this.centraliSel.length > 0) {
                for (var csel in this.centraliSel) {
                    let c = this.centraliSel[csel].split("-")
                    let cent = this.tableData[parseInt(c[1])]
                    if (this.selectedGroup=="")
                    {
                        this.$store.dispatch('sendCablecomCommand', {cu_command,cu_type: cent.cu_type, cu_id: cent.cu_id, addr: 'FFFF'})
                    }
                    else
                    {
                       var groupAddress="FFE"+(parseInt(this.selectedGroup)-1).toString(16).toUpperCase();
                       this.$store.dispatch('sendCablecomCommand', {cu_command,cu_type: cent.cu_type, cu_id: cent.cu_id, addr: groupAddress}) 
                    }   
                }
            } 
            else if (this.lampadeSel.length > 0) {
                var delay = 100;
                for (var lsel in this.lampadeSel) {
                    let l = this.lampadeSel[lsel].split("-")
                    let cent = this.tableData[parseInt(l[1])]
                    let lamp = cent.lamps[parseInt(l[2])]
                    console.log("mando comando a centrale " + cent.cu_id+", lampada: " + lamp.id)
                    setTimeout(function() {
                        self.$store.dispatch('sendCablecomCommand', {cu_command,cu_type: cent.cu_type, cu_id: cent.cu_id, addr: lamp.id})
                    }, delay)
                    delay += 2000
                    
                }
            } 
            else
            {   
                var alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: "Nessun dispositivo selezionato",
                    countDownChanged: function(cd) {
                        //timeLeft = cd;
                        console.log("countdownchanged:" + cd)
                    }
                }  
                this.alerts.push(alert);  
            }
        },
        /*rimosso blinking su identifica*/
        /*blinkingTimer()
        {
            if(this.blinkActive > 0) {
                    setTimeout(() => {
                        this.blinkActive -= 1
                        this.blinkingTimer();
                        console.log ("Blinka",this.blinkActive);
                    }, 1000)
            }
            else 
            {
                if (this.blinking){this.sendGenericCommand('stop_blink');}
            }
        },*/
        sendPianificaTest(cu_command) {
            console.log("pianificaTest",cu_command);
            let self = this
            if (this.centraliSel.length > 0) {

                this.cmdPianificaTest = cu_command;

                if (cu_command.set_functional != "") {
                    cu_command.command = "setDateTimeFunzionale";
                } else {
                    cu_command.command = "setDateTimeAutonomia";
                }

                for (var csel in this.centraliSel) {
                    let c = this.centraliSel[csel].split("-")
                    let cent = this.tableData[parseInt(c[1])]
                    //cu_command.command="pianificaTest";
                    console.log("Set Pianifica test",cu_command,cent.cu_type,cent.cu_id);
                    this.$store.dispatch('sendCablecomCommand', {cu_command,cu_type: cent.cu_type, cu_id: cent.cu_id, addr: 'FFFF'})
                }
            }
            else
            {
                var alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: "Nessuna centrale selezionata",
                    countDownChanged: function(cd) {
                        //timeLeft = cd;
                        console.log("countdownchanged:" + cd)
                    }
                }  
                this.alerts.push(alert);  
            }
        },
        async sendDeleteLogicaSerialId(centType,centId) {
           let self = this;
           var cu_command = {};
           cu_command.command="setLgSerialId";
           Vue.nextTick(function () {
                        self.headerClose = false;
                        self.configError = false;
                        self.configCompleted = false;
                        self.lamp_found = 0;
                    })
            console.log("invio comando logica per reset lista lampade");
                var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: centType, cu_id: centId, page: 255,  lamp_id: ["0000"], initialRetry: 3});
                console.log("ricevuta risposta da promise!!!", resp);
                if (resp.error != null && resp.error != "") {
                    console.log("comando fallito!");
                    return;
                }
                setTimeout(function() {
                    self.currentCent = null;
                    self.configCompleted = false;
                    self.configInProgress = false;
                    self.$bvModal.hide('config-cent-modal');
                    self.headerClose = true;
                },1000);
        },


        async sendDeleteMultiLogicaSerialId(centType,centId) {
            let self = this;
            Vue.nextTick(function () {
                        self.headerClose = false;
                        self.configError = false;
                        self.configCompleted = false;
                        self.lamp_found = 0;
                    })
            var lampId=this.currentCent.lamps_id; 
            var cu_command = {};
            cu_command.command="setLgSerialId";
            var error_preset=false;
            var pages=[];

            console.log("invio comando logica per reset lista lampade");
            var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: centType, cu_id: centId, page: 255,  lamp_id: ["0000"], initialRetry: 3});
            console.log("ricevuta risposta da promise!!!", resp);
            if (resp.error != null && resp.error != "") {
                console.log("comando fallito!");
                error_preset=true;
                return;
            }
            if (!this.deleteAllLamps) {

                var fillArray = Array(128).fill("0000");
                
                
                //poi riempo i buchi
                var index = 0;
                for (var i=0; i< lampId.length; i++) {
                    var ser = lampId[i];
                    if (this.substituteLampsSelection.indexOf(ser) >= 0) {
                        console.log("rimuovo lampada " + ser);
                        continue;
                    }

                    while (fillArray[index] != "0000" && index < 128) index++;
                    if (index < 128) {
                        fillArray[index] = ser;
                        var page = Math.floor(index / 32);
                        if (pages.indexOf(page) < 0 ) pages.push(page);
                    }
                    index++;
                }

                console.log("array lampid rivisitato:",fillArray,pages);
                

                for (var p=0; p<pages.length; p++ )
                {
                    var page = pages[p];

                    var lampsId = fillArray.slice(page*32,Math.min((page+1)*32,fillArray.length) )
                        
                    console.log("invio comando logica per pagina " + page,lampsId );
                    var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: centType, cu_id: centId, page: page,  lamp_id: lampsId, initialRetry: 3});
                    console.log("ricevuta risposta da promise!!!", resp);
                    if (resp.error != null && resp.error != "") {
                        console.log("comando fallito!");
                        error_preset=true;
                        break;
                    }
                }       
            }     
            
            if(error_preset==false)
                    {
                      console.log("comando setting buffer serial Id completato! Invio la ricerca con logica preset");
                      let modalita_config_logica="logica_preset";
                      this.$store.dispatch('sendLogicaConfigCommand', {centType, centId, modalita_config_logica});  
                    }
            setTimeout(function() {
                self.currentCent = null;
                self.configCompleted = false;
                self.configInProgress = false;
                self.$bvModal.hide('config-cent-modal');
                self.headerClose = true;
            },1000);
            
        },

        async sendPresetLogicaSerialId(serialId_list,centType,centId) {
            let self = this;
            Vue.nextTick(function () {
                        self.headerClose = false;
                        self.configError = false;
                        self.configCompleted = false;
                        self.lamp_found = 0;
                    })
            var lampId=serialId_list; 
            var cu_command = {};
            cu_command.command="setLgSerialId";
            var error_preset=false;
            var pages=[];

            if (this.manual_mode_logica != "overwrite") {
                //devo aggiungere le lampade già presenti alla mia lista
                //var cent_lamps_array = []
                for(var n=0;n<this.currentCent.lamps_id.length;n++) {
                    //cent_lamps_array.push(this.currentCent.lamps_id[n]);
                    //lampId.push(this.currentCent.lamps_id[n]);
                    lampId.unshift(this.currentCent.lamps_id[this.currentCent.lamps_id.length - 1 - n]);
                }
                //lampId = lampId.concat(cent_lamps_array);
            }

            //if (this.manual_mode_logica == 'overwrite') {
                console.log("invio comando logica per reset lista lampade");
                var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: centType, cu_id: centId, page: 255,  lamp_id: ["0000"], initialRetry: 3});
                console.log("ricevuta risposta da promise!!!", resp);
                if (resp.error != null && resp.error != "") {
                    console.log("comando fallito!");
                    error_preset=true;
                    return;
                }
                var fillArray = Array(128).fill("0000");
                
                //prima riempo le posizioni forzate
                for (var i=0; i< lampId.length; i++) {
                    var ser = lampId[i];
                    var pd = ser.indexOf(":");
                    if (pd > 0) {
                        var pos = parseInt(ser.substr(0,pd),10);
                        fillArray[pos-1] = ser.substr(pd+1);
                        var page = Math.floor(pos/32);
                        if (pages.indexOf(page) < 0 ) pages.push(page);
                    }
                }
                //poi riempo i buchi
                var index = 0;
                for (var i=0; i< lampId.length; i++) {
                    var ser = lampId[i];
                    var pd = ser.indexOf(":");
                    if (pd > 0) {
                        //le lampade con posizione fissa le ho già gestite
                        continue;
                    }
                    while (fillArray[index] != "0000" && index < 128) index++;
                    if (index < 128) {
                        fillArray[index] = ser;
                        var page = Math.floor(index / 32);
                        if (pages.indexOf(page) < 0 ) pages.push(page);
                    }
                    index++;
                }

                console.log("array lampid rivisitato:",fillArray,pages);

                for (var p=0; p<pages.length; p++ )
                {
                    var page = pages[p];

                    var lampsId = fillArray.slice(page*32,Math.min((page+1)*32,fillArray.length) )
                        
                    console.log("invio comando logica per pagina " + page,lampsId );
                    var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: centType, cu_id: centId, page: page,  lamp_id: lampsId, initialRetry: 3});
                    console.log("ricevuta risposta da promise!!!", resp);
                    if (resp.error != null && resp.error != "") {
                        console.log("comando fallito!");
                        error_preset=true;
                        break;
                    }
                }


            /*} else {
                pages.push(0);
        
                if(lampId.length/32>1) pages.push(1);
                if(lampId.length/64>1) pages.push(2);
                if(lampId.length/96>1) pages.push(3);
                    
                for (var p=0; p<pages.length; p++ )
                {
                    var page = pages[p];

                    var lampsId = lampId.slice(page*32,Math.min((page+1)*32,lampId.length) )
                        
                    console.log("invio comando logica per pagina " + page, lampsId );
                    var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: centType, cu_id: centId, page: page,  lamp_id: lampsId, initialRetry: 3});
                    console.log("ricevuta risposta da promise!!!", resp);
                    if (resp.error != null && resp.error != "") {
                        console.log("comando fallito!");
                        error_preset=true;
                        break;
                    }
                }
            }*/

            
            
            if(error_preset==false)
                    {
                      console.log("comando setting buffer serial Id completato! Invio la ricerca con logica preset");
                      let modalita_config_logica="logica_preset";
                      this.$store.dispatch('sendLogicaConfigCommand', {centType, centId, modalita_config_logica});  
                    }
            setTimeout(function() {
                self.currentCent = null;
                self.configCompleted = false;
                self.configInProgress = false;
                self.$bvModal.hide('config-cent-modal');
                self.headerClose = true;
            },1000);
            
        },
        async sendSubstituteLogicaSerialId(serialId_list,centType,centId) {
            let self = this;
            Vue.nextTick(function () {
                        self.headerClose = false;
                        self.configError = false;
                        self.configCompleted = false;
                        self.lamp_found = 0;
                    })
            var lampId=this.currentCent.lamps_id; 
            var cu_command = {};
            cu_command.command="setLgSerialId";
            var error_preset=false;
            var pages=[];

            for (var i=0; i<serialId_list.length; i++) {
                var oldId = this.substituteLampsSelection[i];
                var oldPos = lampId.indexOf(oldId);
                if (oldPos >= 0) {
                    lampId[oldPos] = serialId_list[i];
                }
            }
            

            
                console.log("invio comando logica per reset lista lampade");
                var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: centType, cu_id: centId, page: 255,  lamp_id: ["0000"], initialRetry: 3});
                console.log("ricevuta risposta da promise!!!", resp);
                if (resp.error != null && resp.error != "") {
                    console.log("comando fallito!");
                    error_preset=true;
                    return;
                }
                var fillArray = Array(128).fill("0000");
                
                
                //poi riempo i buchi
                var index = 0;
                for (var i=0; i< lampId.length; i++) {
                    var ser = lampId[i];
                    while (fillArray[index] != "0000" && index < 128) index++;
                    if (index < 128) {
                        fillArray[index] = ser;
                        var page = Math.floor(index / 32);
                        if (pages.indexOf(page) < 0 ) pages.push(page);
                    }
                    index++;
                }

                console.log("array lampid rivisitato:",fillArray,pages);

                for (var p=0; p<pages.length; p++ )
                {
                    var page = pages[p];

                    var lampsId = fillArray.slice(page*32,Math.min((page+1)*32,fillArray.length) )
                        
                    console.log("invio comando logica per pagina " + page,lampsId );
                    var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: centType, cu_id: centId, page: page,  lamp_id: lampsId, initialRetry: 3});
                    console.log("ricevuta risposta da promise!!!", resp);
                    if (resp.error != null && resp.error != "") {
                        console.log("comando fallito!");
                        error_preset=true;
                        break;
                    }
                }            
            
            if(error_preset==false)
                    {
                      console.log("comando setting buffer serial Id completato! Invio la ricerca con logica preset");
                      let modalita_config_logica="logica_preset";
                      this.$store.dispatch('sendLogicaConfigCommand', {centType, centId, modalita_config_logica});  
                    }
            setTimeout(function() {
                self.currentCent = null;
                self.configCompleted = false;
                self.configInProgress = false;
                self.$bvModal.hide('config-cent-modal');
                self.headerClose = true;
            },1000);
            
        },
        async sendGenericCommandMulti(cu_command) {
            let self = this
            if (this.centraliSel.length > 0) {
                console.log("SELEZIONE SU CENTRALI",this.centraliSel);
                for (var csel in this.centraliSel) {
                    let c = this.centraliSel[csel].split("-")
                    let cent = this.tableData[parseInt(c[1])]
                    var indexes=[];
                    var pages = [];
                    for (var k=0;k<cent.lamps.length;k++)
                    {
                       let lamp = cent.lamps[k];
                       indexes.push(lamp.index);
                       let lampPage = Math.floor(lamp.index / 32);
                        if (!pages.includes(lampPage)) pages.push(lampPage);
                    }
                    if (cent.cu_type == 'logica') {
                        //create 32 indexes for broadcast command on a central unit logica
                        var indexes=[];
                        for (var k=0;k<32;k++)
                        {
                            indexes.push(k);
                        }
                        //setting page=255 for broadcast command on a central unit logica
                        var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: cent.cu_type, cu_id: cent.cu_id, page: 255,  indexes: indexes, initialRetry: 3});
                    } else {
                        self.$store.dispatch('sendCablecomCommand', {cu_command,cu_type: cent.cu_type, cu_id: cent.cu_id, indexes: indexes});
                    }
                    
                    console.log("Multi: ",cu_command);
                    console.log("Multi: mando comando a centrale " + cent.cu_id +", lampade: " + indexes);
                  }
            } if (this.lampadeSel.length > 0) {
                console.log("SELEZIONE SU LAMPADE",this.lampadeSel);
                var cent = null;
                var tempCentId = null;
                var tempCentType=null;
                var indexes = [];
                var pages = [];
                for (var lsel in this.lampadeSel) {
                    let l = this.lampadeSel[lsel].split("-");
                    cent = this.tableData[parseInt(l[1])];
                    console.log("MULTI sono su cent",cent.cu_id);
                    if (tempCentId!=cent.cu_id || tempCentType!=cent.cu_type)
                    {
                        if (tempCentId != null && tempCentType!=null ) {
                            if (tempCentType == 'logica') {
                                for (var p=0; p<pages.length; p++ ) {
                                    var page = pages[p];
                                    //estraggo gli indici di questa pagina
                                    var lampPageIndexes = indexes.filter(function(lampIdx) {
                                        let pidx = Math.floor(lampIdx / 32);
                                        return pidx == page;
                                    });
                                    console.log("invio comando logica per pagina " + page + " indici:" + lampPageIndexes);
                                    var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: tempCentType, cu_id: tempCentId, page: page,  indexes: lampPageIndexes, initialRetry: (p == 0) ? 3 : 41 });
                                    console.log("ricevuta risposta da promise!!!", resp);
                                    if (resp.error != null && resp.error != "") {
                                        console.log("comando fallito!");
                                        error_loop_page=true;
                                        break;
                                    }
                                }
                            } else {
                                self.$store.dispatch('sendCablecomCommand', {cu_command,cu_type: tempCentType, cu_id: tempCentId, indexes: indexes});
                            }
                            console.log("MULTI 1 mando comando a centrale " + tempCentId+", lampade: " + indexes);
                        }
                        
                        indexes=[];
                        pages = [];
                    }
                    tempCentId=cent.cu_id;
                    tempCentType=cent.cu_type;
                    let lamp = cent.lamps[parseInt(l[2])];
                    indexes.push(lamp.index);
                    let lampPage = Math.floor(lamp.index / 32);
                    if (!pages.includes(lampPage)) pages.push(lampPage);
                    
                    console.log("MULTI lamp,indexes su cent",cent.cu_id + " indexes " + indexes + " lamps " + lamp.index + " pages: ",  pages);
                }   
                if (cent.cu_type == 'logica') {
                    
                    var error_batch=false;
                    if(pages.length>1)
                    {
                        //Invio comando di apertura batch se comando multi su più pagine param=01 (apertura store batch)
                        var temp_command=cu_command;
                        var cu_command = {};
                        cu_command.command="setBatch";
                        console.log("Apro batch comandi",cu_command);
                        var resp_batch=await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: cent.cu_type, cu_id: cent.cu_id, param: "01", initialRetry: 3});
                        cu_command=temp_command;

                       if (resp_batch.error != null && resp_batch.error != "") {
                            console.log("comando batch fallito!");
                            error_batch=true;
                        }
                    }    
                    
                    if(error_batch==false)
                        {
                            for (var p=0; p<pages.length; p++ ) {
                                var page = pages[p];
                                //estraggo gli indici di questa pagina
                                var lampPageIndexes = indexes.filter(function(lampIdx) {
                                let pidx = Math.floor(lampIdx / 32);
                                return pidx == page;
                                });
                                console.log("invio comando logica per pagina " + page + " indici:" + lampPageIndexes);
                                var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: cent.cu_type, cu_id: tempCentId, page: page,  indexes: lampPageIndexes, initialRetry: 3});
                                console.log("ricevuta risposta da promise!!!", resp);
                                if (resp.error != null && resp.error != "") {
                                    console.log("comando fallito!");
                                    var resp_batch=await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: cent.cu_type, cu_id: cent.cu_id, param: "02", initialRetry: 3});
                                    break;
                                }
     
                                if(p==pages.length-1 && pages.length>1)
                                    {
                                        //Invio comando di esecuzione batch (chiusura batch comandi + esecuzione) param=03 (esegui batch)
                                        var cu_command = {};
                                        cu_command.command="setBatch";
                                        console.log("Chiudo batch comandi",cu_command);
                                        var resp_batch=await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: cent.cu_type, cu_id: cent.cu_id, param: "03", initialRetry: 3});
                                        if (resp_batch.error != null && resp_batch.error != "") 
                                            console.log("comando batch fallito!");
                                    }

                            }        
                        }
                } else {
                    self.$store.dispatch('sendCablecomCommand', {cu_command,cu_type: cent.cu_type, cu_id: tempCentId, indexes: indexes});
                }
                
                console.log("MULTI 2 mando comando a centrale after " + tempCentId +", lampade: " + indexes);
                


            } if (this.centraliSel.length <= 0 && this.lampadeSel.length <= 0)
            {   
                var alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: "Nessun dispositivo selezionato",
                    countDownChanged: function(cd) {
                        //timeLeft = cd;
                        console.log("countdownchanged:" + cd)
                    }
                }  
                this.alerts.push(alert);  
            }
        },
        azzeraSelezione() {
            this.righeSel = [];
        },
        selezionaAllCentrali() {
            
            this.righeSel = []
            for (var i=0; i< this.tableData.length; i++) {
                if (this.tableData[i].enabled) this.righeSel.push("cent-"+i);
            }
            //console.log("righeSel:",this.righeSel);
            
        },
        toggleSeleziona(ev)
        {
            let c = document.getElementById("allSelect");
           console.log("toggleSeleziona ev",ev,c.checked);
           //console.log ("STATUS", this.status);
           if (c.checked) {
            this.selezionaAllCentrali();
            
           }
           else {
            this.azzeraSelezione();
            
            //this.status = "none_selected";
           } 
           //let self = this;
           

        },
        selezionaAllLamp() {
            this.righeSel = [];
            for (var i=0; i< this.tableData.length; i++) {
                let c = this.tableData[i];
                for (var l = 0; l < c.lamps.length; l++) {
                    this.righeSel.push("lamp-" + i + "-" + l)
                }
            }
        },
        toggleCentCheckbox(ev) {
            if (this.lampadeSel.length > 0) {
                for (var i=this.righeSel.length-1; i>=0; i--) {
                    if (this.righeSel[i].substr(0,1) == 'l') {
                        this.righeSel.splice(i,1)
                    }
                }
            }
            console.log("righe:",this.righeSel);
        },
        showRemoveCu(cuRemove)
        {
           this.cuToRemove = cuRemove;
           this.modalRemoveCuVisible = true;
           console.log("Current Cu to remove", this.cuToRemove);
        },
        resetRemoveCuModal() {
            this.cuToRemove = null;
        },
        showAdvanced(cu)
        {
           this.cuAdvanced = cu;
           this.modalAdvancedCuVisible = true;
           console.log("Open modal advanced on Cu", this.cuAdvanced);
        },
        resetAdvancedCuModal() {
            this.cuAdvanced = null;
        },
        showGroups(cu)
        {
           this.cuGroups = cu;
           this.modalGroupsCuVisible = true;
           console.log("Open modal groups on Cu", this.cuGroups);
        },
        resetGroupsCuModal() {
            this.cuGroups = null;
        },
        showCentDetails(centDetails) {
            console.log("mostro dettaglio centrale ", centDetails)
            this.currentCent = centDetails;
            let self = this
            Vue.nextTick(function () {
                self.$bvModal.show('dett-cent-modal');
            })
        },
        showConfigCent(centConfig) {
            this.currentCent = centConfig;
            this.configInProgress=0;
            this.selected_modalita_logica=null;
            this.logica_config_sn='';
            this.logica_array_sn=[];
            this.logica_cu_list='';
            this.delete_sn=false;
            for(var n=0;n<this.currentCent.lamps_id.length;n++)
            {
                this.logica_cu_list=this.logica_cu_list+this.currentCent.lamps_id[n] + "\n";
            }

            let self = this
            Vue.nextTick(function () {
                self.$bvModal.show('config-cent-modal');
            })
        },
        sendConfigCent(evt, centType, centId) {
            let self = this
            evt.preventDefault()
            //selezionata modalità logica di inserimento dei serial number di lampada
            console.log("sendconfigCent!");

            if(centType=="logica" && this.selected_modalita_logica=="logica_preset")
            {
               self.hasValidationError = false;
               if(this.validateSerialList(this.logica_config_sn))
               {
                   this.sendPresetLogicaSerialId(this.logica_array_sn,centType,centId);
               } else {
                   setTimeout(function() {
                       self.hasValidationError = true;
                   },100);
                   return false;
               }
            } else if(centType=="logica" && this.selected_modalita_logica=="logica_substitute")
            {
               self.hasValidationError = false;
               console.log("check sostituzione!");
               if(this.validateSubstituteList(this.logica_config_sn))
               {
                   this.sendSubstituteLogicaSerialId(this.logica_array_sn,centType,centId);
               } else {
                   setTimeout(function() {
                       self.hasValidationError = true;
                   },100);
                   return false;
               }
            }
            else if(centType=="logica" && this.selected_modalita_logica=="logica_delete")
            {
                self.hasValidationError = false;
                if (!this.deleteAllLamps && this.substituteLampsSelection.length == 0) {

                    alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg:this.$t("config_cu_modal.logica_sn_empty_delete"),
                        countDownChanged: function(cd) {
                            console.log("countdownchanged:" + cd)
                        }
                    }  
                    this.validation_alerts.push(alert); 
                    console.log("nessuna lampada sel per delete");

                   setTimeout(function() {
                       self.hasValidationError = true;
                   },100);
                   return false;

                }

                this.delete_sn=true;

            }
            //selezionata la modalità di ricerca per logica o per cablecom
            else
            {
                if (centType=="cablecom")
                {
                    let num_lamp=this.selected_num_lamp;
                    let ore_autonomia=this.selected_ore_autonomia;
                    this.$store.dispatch('sendCablecomConfigCommand', {centType, centId, num_lamp, ore_autonomia});
                }
                else if (centType=="logica")
                {
                let modalita_config_logica=this.selected_modalita_logica;
                this.$store.dispatch('sendLogicaConfigCommand', {centType, centId, modalita_config_logica});  
                }           
                    let self = this
                    Vue.nextTick(function () {
                        self.headerClose = false;
                        self.configError = false;
                        self.configCompleted = false;
                        self.configInProgress = setTimeout(self.checkConfigStatus, 5000);
                        self.lamp_found = 0;
                    })
            }
        },
        checkConfigStatus() {
            console.log("check config status...");
            this.$store.dispatch('sendCablecomConfigStatusCommand', {cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id});
        },
        showLampDetails(cent,lamp) {
            console.log("mostro dettaglio lampada ", lamp.id, "su centrale",cent.cu_id);
            this.currentLamp = lamp;
            this.currentCent = cent;
            this.qrScanned = "";
            this.scanning = false;
            let self = this
            Vue.nextTick(function () {
                console.log("Show");
                self.$bvModal.show('dett-lamp-modal');
            })
        },
        showLampBlink(cent,lamp) {
            console.log("lampada da blinkare lampada ", lamp.id, "su centrale",cent.cu_id);
            this.currentLamp = lamp;
            this.currentCent = cent;
            this.blinking=false;
            let self = this
            Vue.nextTick(function () {
                console.log("Show");
                self.$bvModal.show('blink-lamp-modal');
            })
        },
        closeCentDetails() {
            console.log("close cent details");
            this.currentCent = null;
        },
        closeLampDetails() {
            console.log("close lamp details");
            this.currentLamp = null;
        },
        closeLampBlink() {
            console.log("close lamp blink su single lamp");
            if(this.blinking){this.sendGenericCommand('stop_blink_single');}
            this.currentLamp = null;
        },
        closeLampGroups() {
            console.log("close lamp groups");
            this.currentLamp = null;
        },
        onlineClass(value) {
            var online = (value.cu_connected) ? "dot-connected" : "dot-disconnected"
            return online
        },
        shadowPendingClass(value) {
            var pending = (value >=0) ? "shadow-pending-true" : "shadow-pending-false"
            return pending
        },
        working(value) {
            if(value.cu_status)
            {
                let s = value.cu_status
                console.log("centrale " +value.cu_type+"_"+value.cu_id + " working=" + value.working);
                if(s.rest_mode_running == 'ON') return false;
                if (value.working == true || s.search_lamp == 'ON' || s.polling_lamp == 'ON' 
                    || s.com_test_running == 'ON' || s.upgrade_fw_running == 'ON' || s.enrollment_running == 'ON') return true;
                return false;
            }
        },
        testactive(value) {
            if(value.cu_status)
            {
                let s = value.cu_status;
                s.working=false;
                if (s.funct_test_running == 'ON'  || s.autonomy_test_running == 'ON') return true;
                return false;
            }
        },
        waiting_first_shadow(value) {
            if(!value.cu_status)
            {
                return true;
            }
            return false;
        },
        restmodeactive(value) {
            if(value.cu_status)
            {
                let s = value.cu_status
                s.working=false;
                if (s.rest_mode_running == 'ON' && value.cu_connected==true) return true;
                return false;
            }
        },
        emergencyactive(value) {
            if(value.cu_status)
            {
                let s = value.cu_status
                s.working=false;
                if (s.emergency_running == "ON") 
                {
                    console.log("emergency active",s.emergency_running);
                    return true;
                }
                return false;
            }
        },
        centErrorClass(value){
            if(value.cu_error)
            {
                var err = value.cu_error;
                var cent_exclamation="cent-no-error";
                if (
                        err.error_batt_low_voltage == 'ON' ||
                        err.error_batt_not_connected == 'ON' ||
                        err.error_duplicated_id_lamp == 'ON' ||
                        err.error_lg == 'ON' ||
                        err.error_wiring == 'ON' ||
                        err.error_overload == 'ON' ||
                        err.error_more_32_lamp_in_config == 'ON'||
                        err.error_more_128_lamp_in_config== 'ON' ||
                        err.err_data_invalid == 'ON' ||
                        err.err_UART1 == 'ON' ||
                        err.err_UART2 == 'ON' || 
                        err.err_UART3 == 'ON' || 
                        err.err_UART3_modem_powerON == 'ON' ||
                        err.err_UART4 == 'ON' || 
                        err.err_UART5 == 'ON' ||
                        err.err_UART6 == 'ON' || 
                        err.err_UART7 == 'ON')
                        {cent_exclamation="cent-error"}
                else if (
                        err.error_missing_lamp_in_config == 'ON' || 
                        err.error_too_much_lamp_in_config == 'ON' ||
                        err.mancanza_rete=='ON' ||
                        value.cu_status.emergency_running =='ON')
                        {cent_exclamation="cent-warning"}        
                return cent_exclamation;  
            }      
        },
        dotClass(value) {
           var stato=null;
           if(value.cu_error)
           {
                if (value.num_lamp_error > 0 || value.cu_error.error_overload == 'ON' || value.cu_error.errorwiring == 'ON') {
                    stato = "fa-exclamation-circle check-err";
                } 
                else if (value.num_lamp_found==0 || value.cu_error.error_missing_lamp_in_config == 'ON' || value.cu_error.error_too_much_lamp_in_config == 'ON' ) {
                    stato = "fa-check check-not-config";
                }
                else
                {   
                    if(value.cu_status.emergency_running =='ON')
                        stato="fa-exclamation-circle emergency-on"
                    else
                        stato="fa-check check-ok";   
                }
                return stato
           }
        },
        dotClassLamp(value) {
        
           var stato_lamp=null;
           
           if(value.error_batt_short=="OFF" && value.error_batt_test=="OFF" && value.error_com=="OFF" && value.error_hardware=="OFF" && value.error_led=="OFF")
           {
              stato_lamp = "fa-check check-ok";
           }
           else {
                stato_lamp = "fa-exclamation-circle check-err";
           } 
        
        return stato_lamp
        },
        GsmClass(value) {
            if(value>=25) return "signal-5"
            if(value>=20 && value<25) return "signal-4"
            if(value>=15 && value<20) return "signal-3"
            if(value>=10 && value<15) return "signal-2"
            if(value>=1 && value<10) return "signal-1"
            return "signal-0"
        }
    }
}
</script>


<style lang="scss">

    .check-ok {
        color: yellowgreen
    }

    .check-err {
        color: red
    }
    
    .check-not-config {
        color: orange
    }

    .emergency-on {
        color: orange
    }

    .cent-error {
       color:red;
       visibility:none;
    }

   .cent-warning {
       color:orange;
       visibility:none;
    }

    .cent-no-error {
       visibility:hidden;
    }

    .shadow-pending-true {
        color: blue
    }

    .shadow-pending-false {
        color: black
    }



  #dataTable2 {
    table-layout: fixed;
    width: 95%;
    margin: 0 auto;
    outline: none;
    font-size: 13px;

    td.dettColumnClass {
        
        width: 60px;
        max-width: 60px;
        min-width: 60xp;
    }
    td.chkColumnClass {
        width: 80px;
        max-width: 80px;
        min-width: 80px;
    }
    td.descColumnClass {
        width: 218px;
    }
    td.imgColumnClass {
        width:132px;
        max-width: 132px;
        min-width: 132px;
    }

    .dot-connected {
        color: yellowgreen
    }

    .dot-disconnected {
        color: grey
    }

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      visibility:hidden;
      display: flex;
    }
    
    .VueTables__search {
      height: 0px;
      margin-left: 0.25rem;
    }

    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table td:nth-child(1) {
        background-color: #F4F4F4; 
        border-top-left-radius: 10px; 
        border-bottom-left-radius: 10px;
    }

    .VueTables__table td:nth-child(2) {
        border-top-left-radius: 10px; 
        border-bottom-left-radius: 10px;
    }


    .VueTables__table td:last-child {
        border-bottom-right-radius: 10px; 
        border-top-right-radius: 10px; 
    }

    .VueTables__table th {
      border: solid 0px;
      text-align: center;
      outline: none;
    }

    .VueTables__table td {
        vertical-align: middle;
        text-align: center;
        outline: none;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    tr.VueTables__row {
        border-radius: 10px !important;
        font-size: 13px;
        margin-bottom: 2px;
        height:90px;
    }
    
    table tr{
        background-color: #F4F4F4;
    }

    
    .VueTables__child-row:hover {
        background-color: #fff;
    }

    .VueTables__child-row thead tr {
        background-color: #fff;
    }

    .VueTables__child-row thead tr:hover {
        background-color: #fff;
    }

    .VueTables__child-row-toggler--closed::before {
       content: "\f105";  // simbolo > di fontawesome
       font-family: FontAwesome;
       font-size: 1.5em;
       font-weight: 700;
       color:black;
    }

    .VueTables__child-row-toggler--closed:hover::before {
       content: "\f105";  // simbolo > di fontawesome
       font-family: FontAwesome;
       font-size: 1.8em;
       font-weight: 700;
       color:#0090CD;
       cursor:pointer;
    }

    .VueTables__child-row-toggler--open::before {
       content: "\f107";  // simbolo basso di fontawesome
       font-family: FontAwesome;
       font-size: 1.5em;
       font-weight: 700;
       color:black;
    }

    .VueTables__child-row-toggler--open:hover::before {
       content: "\f107";  // simbolo basso di fontawesome
       font-family: FontAwesome;
       font-size: 1.8em;
       font-weight: 700;
       color:#0090CD;
       cursor:pointer;
    }

    .VueTables__table .sp_cent_cod {
        margin-left: 20px;
    }

    .VueTables__table tr.cent-disabled td {
        background-color: rgba(124, 112, 112, 0.301);
    }
    .VueTables__table tr.cent-disabled td:nth-child(1) {
        background-color: #f4f4f4;
    }

    img.disabled {
        opacity: 0.1;
    }

  }


 #dataTableChild {
  td:nth-child(2) {
        background-color: #F4F4F4; 
    }
  td:nth-child(3) {
        border-top:solid 1pt #E3E6E7;
        border-left: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
        border-top-left-radius: 10px; 
        border-bottom-left-radius: 10px;
    }
   td:nth-child(4) {
        border-top:solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }
       td:nth-child(5) {
        border-top:solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }   td:nth-child(6) {
        border-top:solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }   td:nth-child(7) {
        border-top:solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }   td:nth-child(8) {
        border-top:solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }   td:nth-child(9) {
        border-top:solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }   td:nth-child(10) {
        border-top:solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }   td:nth-child(11) {
        border-top:solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }   td:nth-child(12) {
        border-top:solid 1pt #E3E6E7;
        border-right: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }
   td {
        border: solid 0px #E3E6E7; 
        //margin-bottom: 2px;
        height:90px;
    }

  }    

</style>